import React, { useEffect, useMemo, useRef, useState } from "react";
import axios, { CancelToken } from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsersSlash, faTag } from "@fortawesome/pro-solid-svg-icons";
import { faClock } from "@fortawesome/pro-regular-svg-icons";
import { StatusCode } from "api/protocols";
import "./clientPortalBooking.scss";
import "../Home/clientPortalHome.scss";
import OrderSummaryLineItem from "components/bookingEngine/orderSummaryLineItem/OrderSummaryLineItem";
import { useHistory, useParams } from "react-router";
import { UserActive } from "api/rpc";
import { dequeue, enqueue, showError, showSuccess } from "redux/actions/ui";
import Card from "components/card/Card";
import FormLayout from "components/form/FormLayout";
import Radio from "components/radio";
import BookingTimer from "components/bookingEngine/bookingTimer/bookingTimer";
import Checkbox from "components/form/checkbox/Checkbox";
import ReactDOM from "react-dom";
import { Select } from "components/select/index";
import Sheet from "components/sheet/Sheet";
import { Dropdown } from "components/dropdown/dropdown";
import useOutsideAlerter from "hooks/useOutsideAlerter/useOutsideAlerter";
import { useStripe } from "@stripe/react-stripe-js";
import Markdown from "components/markdown/Markdown";
import { LocaleCurrency } from "helpers/Locale";
import Spin from "components/spin/spin";
import { IBookingParticipant } from "redux/reducers/models/teetime";
import GolferCard from "components/bookingPopUp/golferCard/GolferCard";
import Popup from "components/popup/Popup";
import validator from "validator";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { ClientPortalNavigation } from "../ClientPortalNavigation";
import { clientPortalUpdate } from "redux/actions/clientPortal";
import moment from "moment";
import { PostCustomerBooking, PostCustomerBookingNote, PutValidateCustomerBooking } from "api/rpc/2024-04/booking";
import { GetBooking } from "api/rpc/2024-04/customer/booking";
import { GetCart, PutCart } from "api/rpc/2024-04/cart";
import {
  GetCustomerFriends,
  ICustomerFriend,
  PostFriends,
  SearchCustomer,
  PostRWGTokenConversion,
  GetOrder,
  ICustomerCreditCard,
} from "api/rpc/2024-04/customer/customer";
import { ITaxLine } from "components/OrderSummary/OrderSummary";
import { useClientPortal } from "../useClientPortal";
import { GetLeagueParticipants } from "api/rpc/2024-04/customer/league";
import { DeleteLockTeeTime, LockTeeTime } from "api/rpc/2024-04/customer/teetime";
import { GetTeeTimesCustomer } from "api/rpc/2022-09/customer/teetime";
import { PostCart, PostCheckout, PostLineItemToCart } from "api/rpc/2024-04/guest/cart";
import { PutCapture } from "api/rpc/2024-04/guest/transaction";
import { PutCompleteOrder } from "api/rpc/guest/order";
import Panel from "components/panel/Panel";
import { MOBILE_WIDTH } from "helpers/ScreenSizes";
import { useWindowSize } from "hooks/useWindowSize/useWindowSize";
import { useTranslation } from "react-i18next";
import Callout from "components/callout/Callout";
import { convertHoles, valueToString } from "helpers/Helpers";
import { isTurnBlockedForEighteenHoles } from "helpers/teeSheetTurn";
import { PostCustomerBookingDeposit, PutCaptureCustomerBookingDeposit } from "api/rpc/2024-04/customer/deposit";
import { IOrder } from "pages/guest/models/order";
import { PostTransactionNew } from "api/rpc/2024-04/customer/transaction";
import CustomerPaymentMethods from "components/customerPaymentMethods/CustomerPaymentMethods";
import { TFacilityPaymentOption } from "redux/reducers/models/facility";
import { ButtonNew as Button } from "components/buttonNew";
import TextField from "components/form/textField/TextField";
import { ICreditBook } from "api/rpc/2024-04/facilityAdmin/customer/customerCredit";
import { ICartLineItem } from "redux/reducers/models/cart";
import { GetGuestGiftCardBalance } from "api/rpc/2024-04/guest/giftCard";
import { Badge } from "components/badge/Badge";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { DEFAULT_CUSTOMER_MAXIMUM_BOOKING_SIZE, getEffectiveMaximumBookingSize } from "../bookingSize";

/**
 * Parse a tee time `start_time` ("HH:mm:ss" or "HH:mm") into seconds since midnight.
 * Returns null when the value cannot be parsed.
 */
function parseStartTimeSeconds(value: string | number | null | undefined): number | null {
  if (value == null) {
    return null;
  }
  const parts = String(value)
    .split(":")
    .map(part => Number(part));
  if (parts.length < 2 || parts.some(part => !Number.isFinite(part))) {
    return null;
  }
  const [hours, minutes, seconds = 0] = parts;
  return hours * 3600 + minutes * 60 + seconds;
}

export type TExtraPlayersTeeTime = {
  tee_time_id: number;
  quantity: number;
};

export interface IClientPortalBookingState {
  holeAmount: number;
  golferAmount: number;
  powerCartAmount: number;
  teeTimeLockExpire: string;

  acceptMarketingEmail: boolean;
  acceptTerms: boolean;
  paymentTermsActive: boolean;

  cart: Record<string, any>;
  loadPutCart: boolean;

  bookingParticipants: Array<Partial<IBookingParticipant>>;
  player2: string;
  player3: string;
  player4: string;
  player5: string;
  player6: string;
  friendsSearchResult2: Array<ICustomerFriend>;
  friendsSearchResult3: Array<ICustomerFriend>;
  friendsSearchResult4: Array<ICustomerFriend>;
  friendsSearchResult5: Array<ICustomerFriend>;
  friendsSearchResult6: Array<ICustomerFriend>;
  newPlayerQuery: string;
  selectedNewPlayer: ICustomerFriend;
  addPlayerModalVisible: boolean;
  searching: boolean;
  customerSearchResult: Array<ICustomerFriend>;
  friendsList: Array<ICustomerFriend>;
  leagueParticipantList: Array<Record<string, any>>;
  disableSingleBooking: boolean;
  disableTwosomeBooking: boolean;
  disableThreesomeBooking: boolean;
  disableFoursomeBooking: boolean;
  allowGuestNames: boolean;
  preventMultipleBookings: boolean;
  /**If prepaid optional setting is set, allow the option of paying at the course */
  payAtCourse: boolean;
  payNow: boolean;
  note: string;
  rwgTokens: Array<any>;
  ridingBySlot: Array<boolean | null>;
  extraPlayersSlots: TExtraPlayersTeeTime[];
  extraPlayersDropdownVisible: boolean;
  extraCartsDropdownVisible: boolean;
  [key: string]: any;
}

export interface ITeeTimeState {
  activeUser: boolean;
}

interface IParams {
  clientShortName: string;
}

interface IPrepaidWarning {
  title: string;
  description: string;
  open: boolean;
}

export enum PaymentStep {
  post_cart = 1,
  post_line_item = 2,
  post_checkout = 3,
  post_transaction = 4,
  confirm_stripe_payment = 5,
  put_capture = 6,
  put_order_complete = 7,
  post_booking = 8,
}

enum DepositStep {
  post_deposit = 1,
  confirm_stripe_payment = 2,
  put_capture = 3,
  complete = 4,
}

export interface IClientPortalPaymentState {
  step: PaymentStep;
  depositStep: DepositStep;
  depositClientSecret: string;
  depositId: number;
  depositPaymentIntent: Record<string, any>;
  cartToken: string;
  order: IOrder;
  transactionId: number;
  clientSecret: string;
  paymentIntent: Record<string, any>;
}

interface IAddFriendState {
  friendsToAdd: Array<Partial<IBookingParticipant>>;
  modalVisible: boolean;
  selectedPlayerIds: Array<number>;
}

//Instead of creditBookId and gift card codes, we prob need the whole object to access the balance
//Use the balance to calculate and pass the remainingPaymentAmount amount
export interface ICustomerPaymentMethodState {
  paymentOption: TFacilityPaymentOption;
  cardPaymentOption: TFacilityPaymentOption;

  //Credit Card
  creditCard: ICustomerCreditCard;

  //Gift card
  giftCardCode: string;
  giftCardPin: string;
  giftCardBalance: number;

  //Credit book
  creditBook: ICreditBook;

  //House account
  accountId: number;

  refreshPaymentMethods?: boolean;
}

function getDesiredPowerCartAmountFromRiders(riderCount: number) {
  if (riderCount <= 0) {
    return 0;
  }
  return Math.ceil(riderCount / 2);
}

function getCartRiderConstraints(cartAmount: number, golferAmount: number) {
  if (cartAmount <= 0) {
    return { minRiders: 0, maxRiders: 0 };
  }
  const maxRiders = Math.min(cartAmount * 2, golferAmount);
  if (cartAmount === 1) {
    return { minRiders: Math.min(1, golferAmount), maxRiders };
  }
  // 2 carts → min 3, 3 carts → min 5, 4 carts → min 7
  return { minRiders: Math.min(cartAmount * 2 - 1, maxRiders), maxRiders };
}

function clearPlayerSearchFields(golferAmount: number) {
  const cleared: Record<string, string | Array<ICustomerFriend>> = {};
  const maxSlot = Math.max(golferAmount, 6);
  for (let slot = 2; slot <= maxSlot; slot++) {
    cleared[`player${slot}`] = "";
    cleared[`friendsSearchResult${slot}`] = [];
  }
  return cleared;
}

function normalizeRidingBySlotForCartAmount(
  ridingBySlot: Array<boolean | null>,
  cartAmount: number,
  golferAmount: number,
  fillToMax = false,
) {
  const slots = new Array(golferAmount).fill(false) as boolean[];
  for (let index = 0; index < Math.min(ridingBySlot.length, golferAmount); index++) {
    slots[index] = ridingBySlot[index] === true;
  }

  const { minRiders, maxRiders } = getCartRiderConstraints(cartAmount, golferAmount);

  let riderCount = slots.filter(isRiding => isRiding).length;

  if (riderCount > maxRiders) {
    for (let index = slots.length - 1; index >= 0 && riderCount > maxRiders; index--) {
      if (slots[index]) {
        slots[index] = false;
        riderCount--;
      }
    }
  }

  const targetRiders = fillToMax ? maxRiders : minRiders;
  if (riderCount < targetRiders) {
    for (let index = 0; index < slots.length && riderCount < targetRiders; index++) {
      if (!slots[index]) {
        slots[index] = true;
        riderCount++;
      }
    }
  }

  return slots;
}

function applyCartsRequiredState(golferAmount: number) {
  const powerCartAmount = getDesiredPowerCartAmountFromRiders(golferAmount);
  const ridingBySlot = Array(golferAmount).fill(true) as boolean[];
  return { powerCartAmount, ridingBySlot };
}

export default function ClientPortalBooking() {
  const history = useHistory();
  const { t } = useTranslation();
  const { clientShortName } = useParams<IParams>();
  const clientPortalStore = useAppSelector(store => store.clientPortalStore);
  const dispatch = useAppDispatch();
  const { Option } = Select;
  const HOME_URL = useClientPortal().getHomePageUrl();
  const windowSize = useWindowSize();
  const [displayRestricted, setDisplayRestricted] = useState<boolean>(true);
  const { getPaymentOptions } = useClientPortal();

  const teeTimeHasPromotion =
    Boolean(clientPortalStore?.selectedTeeTime?.promotion_type) &&
    clientPortalStore?.selectedTeeTime?.promotion_value != null;

  const stripe = useStripe();

  const [activeUser, setActiveUser] = useState(false);
  const [holeButtons, setHoleButtons] = useState([true, true]);
  const [loadingComplete, setLoadingComplete] = useState(false);

  const [friendsAdded, setFriendsAdded] = useState<boolean>(false);

  const [paymentMethodState, setPaymentMethodState] = useState<ICustomerPaymentMethodState>({
    paymentOption: null,
    cardPaymentOption: null,

    creditCard: null,

    giftCardCode: "",
    giftCardPin: "",
    giftCardBalance: null,

    creditBook: null,

    accountId: null,

    refreshPaymentMethods: false,
  });

  const { getDisabledBookings } = useClientPortal();

  const [addFriendState, setAddFriendState] = useState<IAddFriendState>({
    friendsToAdd: [],
    modalVisible: false,
    selectedPlayerIds: [],
  });

  const [prepaidWarning, setPrepaidWarning] = useState<IPrepaidWarning>({
    title: "",
    description: "",
    open: false,
  });

  const [bookingState, setBookingState] = useState<IClientPortalBookingState>({
    holeAmount: 18,
    golferAmount: 1,
    powerCartAmount: 0,
    teeTimeLockExpire: "",

    acceptMarketingEmail: false,
    acceptTerms: false,
    paymentTermsActive: false,

    cart: null,
    loadPutCart: false,
    bookingParticipants: [],
    player2: "",
    player3: "",
    player4: "",
    player5: "",
    player6: "",
    friendsSearchResult2: [],
    friendsSearchResult3: [],
    friendsSearchResult4: [],
    friendsSearchResult5: [],
    friendsSearchResult6: [],
    newPlayerQuery: "",
    selectedNewPlayer: null,
    addPlayerModalVisible: false,
    searching: false,
    customerSearchResult: [],
    friendsList: [],
    leagueParticipantList: [],
    disableSingleBooking: false,
    disableTwosomeBooking: false,
    disableThreesomeBooking: false,
    disableFoursomeBooking: false,
    allowGuestNames: false,
    preventMultipleBookings: false,
    payAtCourse: true,
    payNow: false,
    note: "",
    rwgTokens: [],
    ridingBySlot: [],
    extraPlayersSlots: [],
    extraPlayersDropdownVisible: false,
    extraCartsDropdownVisible: false,
  });

  const [paymentState, setPaymentState] = useState<IClientPortalPaymentState>({
    step: PaymentStep.post_cart,
    depositStep: DepositStep.post_deposit,
    depositClientSecret: null,
    depositPaymentIntent: null,
    depositId: null,
    cartToken: null,
    order: null,
    transactionId: null,
    clientSecret: null,
    paymentIntent: null,
  });

  const [paymentDueState, setPaymentDueState] = useState({
    dueNow: 0,
    dueAtCourse: 0,
    depositDue: 0,
  });

  const creditCardRequired = Boolean(
    bookingState?.cart?.credit_card_required ?? clientPortalStore?.selectedTeeTime?.credit_card_required,
  );

  const effectiveMaximumBookingSize = getEffectiveMaximumBookingSize(
    clientPortalStore?.teeSheetSettings?.customer_maximum_booking_size,
    clientPortalStore?.teeSheetSettings?.max_booking_size,
    clientPortalStore?.selectedTeeTime?.size,
  );
  const primaryTeeCapacity = Number(clientPortalStore?.selectedTeeTime?.quantity_remaining ?? 0);
  const singleTeeBookingMax = Math.min(
    primaryTeeCapacity,
    Number(clientPortalStore?.selectedTeeTime?.size ?? DEFAULT_CUSTOMER_MAXIMUM_BOOKING_SIZE),
    Number(clientPortalStore?.teeSheetSettings?.max_booking_size ?? DEFAULT_CUSTOMER_MAXIMUM_BOOKING_SIZE),
  );
  // Multi-tee (+) only when this tee is fully open and consecutive same-division capacity exists
  const canSplitAcrossTeeTimes =
    primaryTeeCapacity >= Number(clientPortalStore?.selectedTeeTime?.size ?? 4) &&
    effectiveMaximumBookingSize > singleTeeBookingMax;
  const singleTeePlayerButtons = useMemo(() => {
    const maxOnTee = Math.max(1, singleTeeBookingMax);
    return Array.from({ length: maxOnTee }, (_, index) => index + 1);
  }, [singleTeeBookingMax]);
  const extraPlayerOptions = useMemo(() => {
    if (!canSplitAcrossTeeTimes) {
      return [];
    }
    const start = singleTeeBookingMax + 1;
    if (effectiveMaximumBookingSize < start) {
      return [];
    }
    return Array.from({ length: effectiveMaximumBookingSize - singleTeeBookingMax }, (_, index) => index + start);
  }, [canSplitAcrossTeeTimes, effectiveMaximumBookingSize, singleTeeBookingMax]);
  const extraPlayersRef = useRef<HTMLDivElement>(null);
  useOutsideAlerter(extraPlayersRef, () =>
    setBookingState(prev => ({ ...prev, extraPlayersDropdownVisible: false })),
  );
  const extraCartsRef = useRef<HTMLDivElement>(null);
  useOutsideAlerter(extraCartsRef, () =>
    setBookingState(prev => ({ ...prev, extraCartsDropdownVisible: false })),
  );
  const extraCartOptions = useMemo(() => {
    const maxCarts = Math.ceil(bookingState.golferAmount / 2);
    if (maxCarts < 3) {
      return [];
    }
    return Array.from({ length: maxCarts - 2 }, (_, index) => index + 3);
  }, [bookingState.golferAmount]);
  const playerSearchSignature = Array.from(
    { length: Math.max(0, bookingState.golferAmount - 1) },
    (_, index) => String(bookingState[`player${index + 2}`] ?? ""),
  ).join("\0");

  const { showPaymentDropdown, showPrepaidOptional } = getPaymentOptions(
    clientPortalStore?.teeSheetSettings?.tee_times_pre_paid_option,
    clientPortalStore?.selectedTeeTime?.pre_paid_required,
    creditCardRequired,
    bookingState?.cart?.booking_fee_required as boolean,
    bookingState?.payNow,
    bookingState?.cart?.line_items?.some(
      (item: Record<string, any>) => item?.product_type !== "Booking Fee" && item?.total_price > 0,
    ) as boolean, //Check if cart contains a non booking fee item with a price > 0
    !clientPortalStore?.selectedTeeTime?.pre_paid_required &&
    bookingState?.payAtCourse &&
    bookingState?.cart?.total_price > 0 &&
    bookingState?.cart?.deposit_amount > 0,
  );

  useEffect(() => {
    if (clientPortalStore?.user == null && clientPortalStore?.selectedTeeTime == null) {
      //Page was refreshed, return to home page
      void returnToHomePage(true);
    } else {
      void getCustomerLoggedIn();
      void getCart();
      void disableHoles();

      //Get league participants if selected time is a league time, else get friends list
      if (clientPortalStore?.selectedTeeTime?.league_id) {
        void getLeagueParticipants();
      } else {
        void getFriendsList();
      }

      const disabledBookings = getDisabledBookings(
        clientPortalStore?.teeSheetSettings?.single_bookings,
        clientPortalStore?.teeSheetSettings?.twosome_bookings,
        clientPortalStore?.teeSheetSettings?.threesome_bookings,
        clientPortalStore?.teeSheetSettings?.foursome_bookings,
        clientPortalStore?.selectedTeeTime?.quantity_remaining,
        clientPortalStore?.selectedTeeTime?.size,
      );

      const golferAmount = clientPortalStore?.initialQuantity
        ? clientPortalStore?.initialQuantity
        : disabledBookings.golferAmount;
      const cartsRequired = clientPortalStore?.selectedTeeTime?.cart_rule === "required";
      const cartsRequiredDefaults = cartsRequired ? applyCartsRequiredState(golferAmount) : null;

      setBookingState(prevState => ({
        ...prevState,
        disableSingleBooking: disabledBookings.disableSingleBookings,
        disableTwosomeBooking: disabledBookings.disableTwosomeBookings,
        disableThreesomeBooking: disabledBookings.disableThreesomeBookings,
        disableFoursomeBooking: disabledBookings.disableFoursomeBookings,
        golferAmount,
        powerCartAmount: cartsRequiredDefaults?.powerCartAmount ?? 0,
        ridingBySlot: cartsRequiredDefaults?.ridingBySlot ?? [],
        teeTimeLockExpire: clientPortalStore?.selectedTeeTimeLock?.expireTime,
        bookingParticipants: [
          {
            customer_id: clientPortalStore?.user?.id,
            full_name: clientPortalStore?.user?.full_name,
            ...(cartsRequiredDefaults ? { isRiding: true } : {}),
          },
        ],
        allowGuestNames: clientPortalStore?.teeSheetSettings?.bookings_allow_guest_names,
      }));

      const primaryCapacity = Number(clientPortalStore?.selectedTeeTime?.quantity_remaining ?? 0);
      if (golferAmount > primaryCapacity) {
        void prepareExtraPlayers(golferAmount).then(extraPlayersSlots => {
          if (extraPlayersSlots) {
            updateBookingState({ extraPlayersSlots });
          }
        });
      }

      window.scrollTo({ top: 0, left: 0 });
    }
  }, []);

  useEffect(() => {
    if (clientPortalStore?.selectedTeeTime) {
      void disableHoles();
    }
  }, [bookingState.golferAmount, clientPortalStore?.selectedTeeTime]);

  const cartsRequired = clientPortalStore?.selectedTeeTime?.cart_rule === "required";

  const cartDriverUiEnabled =
    Boolean(clientPortalStore?.teeSheetSettings?.enable_cart_bookings) &&
    (clientPortalStore?.selectedTeeTime?.cart_rule === "optional" ||
      clientPortalStore?.selectedTeeTime?.cart_rule === "required");

  useEffect(() => {
    if (!cartDriverUiEnabled) {
      return;
    }
    setBookingState(prev => {
      const golferCount = prev.golferAmount;
      const prevSlots = prev.ridingBySlot;

      if (cartsRequired) {
        const { powerCartAmount, ridingBySlot } = applyCartsRequiredState(golferCount);
        if (
          prev.powerCartAmount === powerCartAmount &&
          prevSlots.length === golferCount &&
          prevSlots.every(value => value === true)
        ) {
          return prev;
        }
        return {
          ...prev,
          powerCartAmount,
          ridingBySlot,
          bookingParticipants: prev.bookingParticipants.map((participant, index) =>
            participant && index < golferCount ? { ...participant, isRiding: true } : participant,
          ),
        };
      }

      if (prevSlots.length === golferCount) {
        return prev;
      }
      const slots = new Array(golferCount).fill(null) as (boolean | null)[];
      for (let index = 0; index < Math.min(prevSlots.length, golferCount); index++) {
        slots[index] = prevSlots[index];
      }
      return { ...prev, ridingBySlot: slots };
    });
  }, [cartDriverUiEnabled, cartsRequired, bookingState.golferAmount]);

  function handlePlayerRidingChange(slotIndex: number, riding: boolean) {
    if (cartsRequired) {
      return;
    }
    setBookingState(prev => {
      let slots = new Array(prev.golferAmount).fill(false) as boolean[];
      for (let index = 0; index < Math.min(prev.ridingBySlot.length, prev.golferAmount); index++) {
        slots[index] = prev.ridingBySlot[index] === true;
      }
      slots[slotIndex] = riding;

      const riderCount = slots.filter(isRiding => isRiding).length;
      let powerCartAmount = prev.powerCartAmount;

      if (riderCount === 0) {
        powerCartAmount = 0;
      } else {
        const { minRiders, maxRiders } = getCartRiderConstraints(powerCartAmount, prev.golferAmount);
        if (powerCartAmount <= 0 || riderCount > maxRiders || riderCount < minRiders) {
          powerCartAmount = getDesiredPowerCartAmountFromRiders(riderCount);
        }
      }

      slots = normalizeRidingBySlotForCartAmount(slots, powerCartAmount, prev.golferAmount);

      const participants = prev.bookingParticipants.map((p, idx) => {
        if (!p || slots[idx] === null || slots[idx] === undefined) {
          return p;
        }
        return { ...p, isRiding: slots[idx] };
      });
      return { ...prev, powerCartAmount, ridingBySlot: slots, bookingParticipants: participants };
    });
  }

  function renderCartDriverToggle(slotIndex: number) {
    if (!cartDriverUiEnabled) {
      return null;
    }
    const isWalkingMode = bookingState.powerCartAmount === 0;
    const disabled = bookingFeePaid || slotIndex + 1 > bookingState.golferAmount || cartsRequired;
    const slotVal = bookingState.ridingBySlot?.[slotIndex] ?? null;
    const radioValue = isWalkingMode ? "walking" : slotVal === true ? "riding" : "walking";

    return (
      <div className="client-portal-booking-cart-driver-toggle">
        <Radio.Group
          name={`riding_tracking_${slotIndex}`}
          value={radioValue}
          onChange={(val: string | number | Record<string, any>) => {
            handlePlayerRidingChange(slotIndex, val === "riding");
          }}
        >
          <Radio.Button disabled={disabled} value={"riding"}>
            <img src="/public/images/powercart2-01.svg" alt="Power Cart" />
          </Radio.Button>
          <Radio.Button disabled={disabled} value={"walking"}>
            <img src="/public/images/icons/personWalking.svg" alt="Person Walking" />
          </Radio.Button>
        </Radio.Group>
      </div>
    );
  }

  useEffect(() => {
    const source = axios.CancelToken.source();
    let mounted = true;
    let timeoutId: NodeJS.Timeout = null;
    if (mounted === true) {
      timeoutId = setTimeout(() => {
        void search(bookingState.newPlayerQuery, "customerSearchResult", source.token);
      }, 500);
    }
    return () => {
      source.cancel("Cancelled");
      mounted = false;
      clearTimeout(timeoutId);
      setBookingState(prevState => ({ ...prevState, customerSearchResult: [] }));
    };
  }, [bookingState.newPlayerQuery]);

  useEffect(() => {
    const sources: Array<ReturnType<typeof axios.CancelToken.source>> = [];
    const timeoutIds: NodeJS.Timeout[] = [];

    for (let slot = 2; slot <= bookingState.golferAmount; slot++) {
      const query = String(bookingState[`player${slot}`] ?? "");
      const source = axios.CancelToken.source();
      sources.push(source);
      timeoutIds.push(
        setTimeout(() => {
          void search(query, `friendsSearchResult${slot}`, source.token);
        }, 500),
      );
    }

    return () => {
      sources.forEach(source => source.cancel("Cancelled"));
      timeoutIds.forEach(clearTimeout);
      setBookingState(prevState => {
        const cleared: Record<string, Array<ICustomerFriend>> = {};
        for (let slot = 2; slot <= prevState.golferAmount; slot++) {
          cleared[`friendsSearchResult${slot}`] = [];
        }
        return { ...prevState, ...cleared };
      });
    };
  }, [playerSearchSignature]);

  useEffect(() => {
    const source = axios.CancelToken.source();

    async function updateCart() {
      updateBookingState({ loadPutCart: true });
      const quantity = bookingState.golferAmount;
      const customerIds: number[] = [];
      for (let index = 0; index < quantity; index++) {
        const participantId = bookingState.bookingParticipants[index]?.customer_id;
        customerIds.push(participantId ?? clientPortalStore.user.id);
      }
      const cartDrivers = cartDriverUiEnabled
        ? customerIds.map((_, index) => bookingState.ridingBySlot?.[index] === true)
        : undefined;
      await PutCart(
        {
          cart_token: localStorage.getItem(
            `${clientShortName}_${clientPortalStore?.selectedFacility?.short_name}_booking_engine_cart_token`,
          ),
          tee_time_id: clientPortalStore?.selectedTeeTime?.id,
          holes: bookingState.holeAmount,
          quantity,
          power_cart_quantity: bookingState.powerCartAmount,
          customer_ids: customerIds,
          customers_riding: cartDrivers,
          prepaid_optional: bookingState?.payNow ?? false,
        },
        false,
        source.token,
      )
        .then(data => {
          if (data.data === "Cancelled") {
            updateBookingState({ cart: null, loadPutCart: false });
          } else {
            updateBookingState({ cart: data.data, loadPutCart: false });
          }
        })
        .catch(err => {
          dispatch(showError(err.message as string));
          updateBookingState({ cart: null, loadPutCart: false });
          return;
        });
    }
    // Update the cart line items on load & when a selection is made
    if (
      localStorage.getItem(
        `${clientShortName}_${clientPortalStore?.selectedFacility?.short_name}_booking_engine_cart_token`,
      ) &&
      bookingState.holeAmount &&
      bookingState.golferAmount &&
      bookingState.powerCartAmount != null &&
      clientPortalStore?.selectedTeeTime &&
      loadingComplete
    ) {
      void updateCart();
    }

    return () => {
      //Cancel request (sets the returned data to 'Cancelled' when request is cancelled)"
      source.cancel("Cancelled");
    };
  }, [
    bookingState.holeAmount,
    bookingState.golferAmount,
    bookingState.powerCartAmount,
    (bookingState.ridingBySlot ?? []).map(value => (value === true ? "1" : value === false ? "0" : "n")).join(""),
    loadingComplete,
    localStorage.getItem(
      `${clientShortName}_${clientPortalStore?.selectedFacility?.short_name}_booking_engine_cart_token`,
    ),
    bookingState.bookingParticipants.map(p => p.customer_id).join(","),
    bookingState?.payAtCourse,
    bookingState?.payNow,
  ]);

  useEffect(() => {
    let dueNow = 0;
    let dueAtCourse = 0;
    let depositDue = 0;

    const deposit = bookingState?.cart?.deposit_amount ?? 0;
    const total = paymentState?.order?.balance ? paymentState?.order?.balance : bookingState?.cart?.total_price ?? 0;
    const isPrepaid = clientPortalStore?.selectedTeeTime?.pre_paid_required;
    const payAtCourse = bookingState?.payAtCourse;
    const payNow = bookingState?.payNow;

    if (isPrepaid) {
      depositDue = 0;
      dueNow = total;
      dueAtCourse = 0;

      setPaymentDueState({ dueNow, dueAtCourse, depositDue });
      return;
    }

    if (payAtCourse && deposit >= total) {
      depositDue = total;
      dueNow = total;
      dueAtCourse = 0;

      setPaymentDueState({ dueNow, dueAtCourse, depositDue });
      return;
    }

    if (payAtCourse && deposit > 0) {
      depositDue = deposit;
      dueNow += deposit;
    }

    bookingState.cart?.line_items?.forEach((item: any) => {
      const isFee = item?.product_type === "Booking Fee";

      if (isFee) {
        // Fees always due now
        dueNow += item.total_price;
        return;
      }

      if (isPrepaid || payNow) {
        // Entire booking must be paid now
        dueNow += item.total_price;
      } else {
        // Paying at course
        dueAtCourse += item.total_price;
      }
    });

    if (!isPrepaid && payAtCourse && deposit > 0 && deposit < total) {
      dueAtCourse = Math.max(0, dueAtCourse - deposit);
    }

    const orderBalance = paymentState?.order?.balance;
    if (typeof orderBalance === "number") {
      dueNow = orderBalance;
    }

    setPaymentDueState({
      dueNow,
      dueAtCourse,
      depositDue,
    });
  }, [
    bookingState?.cart,
    bookingState?.payAtCourse,
    bookingState?.payNow,
    clientPortalStore?.selectedTeeTime?.pre_paid_required,
    paymentState?.order,
  ]);

  useEffect(() => {
    if (!showPrepaidOptional) {
      setBookingState(prev => ({ ...prev, payAtCourse: true, payNow: false }));
    }
  }, [showPrepaidOptional]);

  const requiresImmediatePayment = useMemo(() => {
    return paymentDueState?.dueNow > 0;
  }, [paymentDueState?.dueNow]);

  const paymentOptions = useMemo(() => {
    if (!clientPortalStore?.selectedFacility) {
      return [];
    }

    return clientPortalStore?.selectedFacility?.payment_options?.reduce((options, option) => {
      //Temporary checks to see if deposit applies. Currently can only pay deposits with credit card. Later will need to add the ability to pay deposits with other payment types
      const isPrepaid = clientPortalStore?.selectedTeeTime?.pre_paid_required;
      const deposit = bookingState?.cart?.deposit_amount ?? 0;
      const total = bookingState?.cart?.total_price?.toFixed(2) ?? 0;
      const depositApplies =
        isPrepaid || bookingState?.payNow || (bookingState?.payAtCourse && deposit > 0 && deposit < total);

      const creditCardOnly =
        (creditCardRequired &&
          paymentDueState?.dueNow === 0 &&
          bookingState?.payAtCourse) ||
        depositApplies;

      //Credit card required, but no payment to be made
      if (creditCardOnly) {
        if (
          option?.type === "card" &&
          option?.processing_type === "terminal" &&
          !options.some(o => o?.type === "card" && o?.processing_type === "terminal")
        ) {
          return [...options, option];
        }

        // Block all other payment types
        return options;
      }

      const updatedOptions = [...options];
      //Use first card type
      if (option?.type === "card" && option?.processing_type === "terminal") {
        if (!options?.some(o => o?.type === "card" && o?.processing_type === "terminal")) {
          updatedOptions.push(option);
        }
      }

      //Other payment types
      if (
        (option?.type === "account" && clientPortalStore?.teeSheetSettings?.web_display_payment_option_account) ||
        (option?.type === "gift_card" && clientPortalStore?.teeSheetSettings?.web_display_payment_option_gift_card) ||
        (option?.type === "credit_book" && clientPortalStore?.teeSheetSettings?.web_display_payment_option_credit_book)
      ) {
        updatedOptions?.push(option);
      }

      return updatedOptions;
    }, [] as Array<TFacilityPaymentOption>);
  }, [clientPortalStore?.selectedFacility, bookingState?.payAtCourse, bookingState?.payNow, requiresImmediatePayment]);

  function updateBookingState(newBookingState: Partial<IClientPortalBookingState>) {
    setBookingState(cur => {
      return { ...cur, ...newBookingState };
    });
  }

  const orderSummaryObjects = [
    {
      lineItem: t("Date"),
      itemValue: moment(clientPortalStore?.selectedTeeTime?.date).format("LL"),
    },
    {
      lineItem: "Time",
      itemValue: moment(clientPortalStore?.selectedTeeTime?.start_time, "hh:mm").format("LT"),
    },
    {
      lineItem: "No. Holes",
      itemValue: convertHoles(
        bookingState.holeAmount,
        clientPortalStore?.selectedFacility?.courses?.find(
          course => course.id === clientPortalStore?.selectedTeeTime?.course_id,
        ),
      ),
    },
    {
      lineItem: "No. Golfers",
      itemValue: bookingState.golferAmount,
    },
    {
      lineItem: "No. Carts",
      itemValue: bookingState.powerCartAmount,
    },
  ];

  const search = async (playerSearchQuery: string, playerSearchResult: string, cancelToken: CancelToken) => {
    try {
      if (playerSearchQuery === "") {
        setBookingState(prevState => ({ ...prevState, [playerSearchResult]: [] }));
        return;
      } else {
        setBookingState(prevState => ({ ...prevState, searching: true }));
        let friendsResults: any;
        if (playerSearchResult === "customerSearchResult") {
          friendsResults = await searchCustomers(cancelToken);
        } else {
          friendsResults = await searchFriends(playerSearchQuery, cancelToken);
        }
        setBookingState(prevState => ({ ...prevState, searching: false, [playerSearchResult]: friendsResults }));
      }
    } catch (error) {
      console.log("err", error);
    }
    return;
  };

  async function getFriendsList() {
    const friendsListRes = await GetCustomerFriends({ facility_id: clientPortalStore?.selectedFacility?.id }, true);
    if (friendsListRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error getting friends list")));
      return;
    }
    setBookingState(prevState => ({ ...prevState, friendsList: friendsListRes.data }));
  }

  async function getLeagueParticipants() {
    const leagueParticipantRes = await GetLeagueParticipants(
      { league_id: clientPortalStore?.selectedTeeTime?.league_id },
      true,
    );
    if (leagueParticipantRes?.status !== StatusCode.OK) {
      dispatch(showError(t("Error getting league participants")));
      return;
    }

    const filteredLeagueParticipants = leagueParticipantRes?.data?.filter(
      (participant: Record<string, any>) => participant?.user_id !== clientPortalStore?.user?.id,
    );
    setBookingState(prevState => ({ ...prevState, leagueParticipantList: filteredLeagueParticipants }));
  }

  async function searchCustomers(cancelToken: CancelToken) {
    let searchCustomersRes;
    const phoneNumberFormats = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(bookingState?.newPlayerQuery);
    if (
      validator.isEmail(bookingState?.newPlayerQuery) ||
      validator.isMobilePhone(bookingState?.newPlayerQuery) ||
      validator.isNumeric(bookingState?.newPlayerQuery) ||
      phoneNumberFormats
    ) {
      searchCustomersRes = await SearchCustomer(
        {
          search: bookingState.newPlayerQuery,
          client_id: clientPortalStore?.client?.id,
          facility_id: clientPortalStore?.selectedFacility?.id,
        },
        false,
        cancelToken,
      );
    } else {
      searchCustomersRes = await SearchCustomer(
        {
          member_search: bookingState.newPlayerQuery,
          client_id: clientPortalStore?.client?.id,
          facility_id: clientPortalStore?.selectedFacility?.id,
        },
        false,
        cancelToken,
      );
      searchCustomersRes.data = searchCustomersRes?.data?.filter(
        (customer: Record<string, any>) => !customer?.customer_type[0]?.default,
      );
    }

    if (searchCustomersRes.status !== StatusCode.OK) {
      if (searchCustomersRes.message !== "Cancelled") {
        dispatch(showError(t("Error getting customers")));
      }
      return [];
    }
    return searchCustomersRes.data as Array<ICustomerFriend>;
  }

  async function searchFriends(playerSearchQuery: string, cancelToken: CancelToken) {
    const searchFriendsRes = await GetCustomerFriends(
      { search: playerSearchQuery, facility_id: clientPortalStore?.selectedFacility?.id },
      false,
      cancelToken,
    );
    if (searchFriendsRes.status !== StatusCode.OK) {
      if (searchFriendsRes.message !== "Cancelled") {
        dispatch(showError(t("Error getting friends list")));
      }
      return [];
    }
    return searchFriendsRes.data;
  }

  async function getCart() {
    //Create a new cart if there is no customer cart token in local storage
    if (
      !localStorage.getItem(
        `${clientShortName}_${clientPortalStore?.selectedFacility?.short_name}_booking_engine_cart_token`,
      )
    ) {
      const getCartRes = await GetCart(
        {
          facility_id: clientPortalStore?.selectedFacility?.id,
          token: localStorage.getItem(
            `${clientShortName}_${clientPortalStore?.selectedFacility?.short_name}_booking_engine_cart_token`,
          ),
        },
        true,
      );
      if (getCartRes.status !== StatusCode.OK) {
        dispatch(showError(t("Error getting cart")));
        return;
      }

      //Set new customer cart token
      localStorage.setItem(
        `${clientShortName}_${clientPortalStore?.selectedFacility?.short_name}_booking_engine_cart_token`,
        getCartRes.data.token as string,
      );

      updateBookingState({ cart: getCartRes.data });
    }
  }

  async function getCustomerLoggedIn() {
    // Check if user is logged in
    if (clientPortalStore?.user == null) {
      dispatch(enqueue());
      const activeUserRes = await UserActive(false);
      dispatch(dequeue());
      if (activeUserRes.status === StatusCode.OK) {
        ReactDOM.unstable_batchedUpdates(() => {
          setActiveUser(true);
          dispatch(clientPortalUpdate({ user: activeUserRes?.data }));
          updateBookingState({
            customerFirstName: activeUserRes.data.first_name,
            customerLastName: activeUserRes.data.last_name,
            customerEmail: activeUserRes.data.email,
            customerPhone: activeUserRes.data.phone,
          });
        });
      } else {
        //User is not logged in, send them back to the home page
        setActiveUser(false);
        dispatch(showError(t("User is not logged in. Please log in and try again.")));
        void returnToHomePage(false);
      }
    } else {
      setActiveUser(true);
    }
  }

  function handleHoleChange(holeAmount: number) {
    updateBookingState({ holeAmount });
  }

  function handleGolferAmountChange(golferAmount: number) {
    // "+" button uses -1; dropdown selection handles amounts above 4
    if (golferAmount === -1) {
      return;
    }

    void (async () => {
      const primaryCapacity = Number(clientPortalStore?.selectedTeeTime?.quantity_remaining ?? 0);
      let extraPlayersSlots: TExtraPlayersTeeTime[] = [];

      if (golferAmount > primaryCapacity) {
        const prepared = await prepareExtraPlayers(golferAmount);
        if (!prepared) {
          return;
        }
        extraPlayersSlots = prepared;
      } else if (bookingState.extraPlayersSlots?.length) {
        // Back within a single tee time — re-lock just the selected tee time
        await LockTeeTime({ tee_time_id: clientPortalStore?.selectedTeeTime?.id }, true);
      }

      if (cartsRequired) {
        const { powerCartAmount, ridingBySlot } = applyCartsRequiredState(golferAmount);
        setBookingState(prevState => ({
          ...prevState,
          golferAmount,
          powerCartAmount,
          ridingBySlot,
          extraPlayersSlots,
          extraPlayersDropdownVisible: false,
          bookingParticipants: prevState.bookingParticipants
            .slice(0, golferAmount)
            .map(participant => (participant ? { ...participant, isRiding: true } : participant)),
          ...clearPlayerSearchFields(golferAmount),
        }));
        return;
      }

      let powerCartAmount = bookingState?.powerCartAmount;
      if (golferAmount < bookingState.golferAmount) {
        void handleRemoveGolfers(golferAmount);
      }

      const maxCartsForGolfers = Math.ceil(golferAmount / 2);
      if (powerCartAmount > maxCartsForGolfers) {
        powerCartAmount = maxCartsForGolfers;
      }

      updateBookingState({
        golferAmount: golferAmount,
        powerCartAmount: powerCartAmount,
        extraPlayersSlots,
        extraPlayersDropdownVisible: false,
      });
    })();
  }

  function handleExtraPlayersVisible() {
    updateBookingState({ extraPlayersDropdownVisible: true });
  }

  function selectExtraPlayersQuantity(quantity: number) {
    handleGolferAmountChange(quantity);
  }

  function extraPlayersMenu() {
    return (
      <ul className="extra-players-menu">
        {extraPlayerOptions.map(playerNum => (
          <li
            key={playerNum}
            className="extra-players-menu-item"
            onClick={() => selectExtraPlayersQuantity(playerNum)}
          >
            <span>{playerNum}</span>
          </li>
        ))}
      </ul>
    );
  }

  function handleExtraCartsVisible() {
    if (cartsRequired) {
      return;
    }
    updateBookingState({ extraCartsDropdownVisible: true });
  }

  function selectExtraCartQuantity(quantity: number) {
    setBookingState(prevState => {
      const ridingBySlot = normalizeRidingBySlotForCartAmount(
        prevState.ridingBySlot ?? [],
        quantity,
        prevState.golferAmount,
        true,
      );
      const bookingParticipants = prevState.bookingParticipants.map((participant, index) => {
        if (!participant || ridingBySlot[index] === undefined) {
          return participant;
        }
        return { ...participant, isRiding: ridingBySlot[index] };
      });

      return {
        ...prevState,
        powerCartAmount: quantity,
        ridingBySlot,
        bookingParticipants,
        extraCartsDropdownVisible: false,
      };
    });
  }

  function extraCartsMenu() {
    return (
      <ul className="extra-carts-menu">
        {extraCartOptions.map(cartNum => (
          <li key={cartNum} className="extra-carts-menu-item" onClick={() => selectExtraCartQuantity(cartNum)}>
            <span>{cartNum}</span>
          </li>
        ))}
      </ul>
    );
  }

  async function prepareExtraPlayers(quantity: number): Promise<TExtraPlayersTeeTime[] | null> {
    const selectedTeeTime = clientPortalStore?.selectedTeeTime;
    if (!selectedTeeTime?.id || !clientPortalStore?.selectedFacility?.id) {
      dispatch(showError(t("Not enough tee times available for selected number of players")));
      return null;
    }

    const primaryCapacity = Number(selectedTeeTime.quantity_remaining ?? 0);
    if (primaryCapacity < 1) {
      dispatch(showError(t("Tee time has no spots available")));
      return null;
    }

    // Multi-tee bookings require a fully open starting tee time and consecutive same-division times
    if (primaryCapacity < Number(selectedTeeTime.size ?? 4)) {
      dispatch(showError(t("Not enough tee times available for selected number of players")));
      return null;
    }

    const extraNeeded = quantity - primaryCapacity;
    const teeTimesRes = await GetTeeTimesCustomer(
      {
        facility_id: clientPortalStore.selectedFacility.id,
        date: selectedTeeTime.date,
        course_id: selectedTeeTime.course_id,
        extended: true,
        turn_tee_time: true,
      },
      true,
    );

    if (teeTimesRes.status !== StatusCode.OK || !teeTimesRes.data?.length) {
      dispatch(showError(t("Not enough tee times available for selected number of players")));
      return null;
    }

    // Same-division tee times from the response. The selected tee time is locked (and
    // fully open times may report 0 remaining), so it may be absent or show 0 here — never
    // rely on the response for the primary; use the store `primaryCapacity` instead.
    const sameDivision = teeTimesRes.data
      .filter(teeTime => teeTime.division_id === selectedTeeTime.division_id)
      .map(teeTime => ({ ...teeTime, startSeconds: parseStartTimeSeconds(teeTime.start_time) }))
      .filter((teeTime): teeTime is typeof teeTime & { startSeconds: number } => teeTime.startSeconds != null)
      .sort((a, b) => a.startSeconds - b.startSeconds);

    const selectedStartSeconds = parseStartTimeSeconds(selectedTeeTime.start_time);
    if (selectedStartSeconds == null) {
      dispatch(showError(t("Not enough tee times available for selected number of players")));
      return null;
    }

    // Determine the tee sheet slot interval from the closest same-division start times.
    const startSecondsList = Array.from(
      new Set<number>([selectedStartSeconds, ...sameDivision.map(teeTime => teeTime.startSeconds)]),
    ).sort((a, b) => a - b);

    let slotInterval = Number.POSITIVE_INFINITY;
    for (let i = 1; i < startSecondsList.length; i++) {
      const delta = startSecondsList[i] - startSecondsList[i - 1];
      if (delta > 0 && delta < slotInterval) {
        slotInterval = delta;
      }
    }

    // Index available tee times by start time so a missing slot signals a gap (booked/blocked).
    const availableByStart = new Map<number, (typeof sameDivision)[number]>();
    for (const teeTime of sameDivision) {
      if (teeTime.id === selectedTeeTime.id) {
        continue;
      }
      availableByStart.set(teeTime.startSeconds, teeTime);
    }

    const extraPlayersSlots: TExtraPlayersTeeTime[] = [];
    let remaining = extraNeeded;
    let expectedStart = selectedStartSeconds + slotInterval;

    while (remaining > 0 && Number.isFinite(slotInterval)) {
      const teeTime = availableByStart.get(expectedStart);
      // No tee time at the next expected slot means it is booked or blocked (not
      // consecutive), so we cannot group any further.
      if (!teeTime || ["blocked", "crossover"].includes(String(teeTime.blocked_type ?? ""))) {
        break;
      }

      let available = Number(teeTime.quantity_remaining ?? 0);
      if (bookingState.holeAmount === 18) {
        const turnRemaining = Number(teeTime.turn_tee_time?.quantity_remaining ?? 0);
        if (
          !teeTime.turn_tee_time ||
          turnRemaining <= 0 ||
          isTurnBlockedForEighteenHoles(teeTime.turn_tee_time?.blocked_type, teeTime.blocked_type)
        ) {
          break;
        }
        available = Math.min(available, turnRemaining);
      }

      if (available <= 0) {
        break;
      }

      const take = Math.min(available, remaining);
      extraPlayersSlots.push({ tee_time_id: teeTime.id, quantity: take });
      remaining -= take;
      expectedStart += slotInterval;
    }

    if (remaining > 0) {
      dispatch(showError(t("Not enough tee times available for selected number of players")));
      return null;
    }

    const teeTimeIds = [selectedTeeTime.id, ...extraPlayersSlots.map(slot => slot.tee_time_id)];
    const lockRes = await LockTeeTime({ tee_time_ids: teeTimeIds }, true);
    if (lockRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error locking tee times")));
      return null;
    }

    return extraPlayersSlots;
  }

  function handleCartChange(cartAmount: number) {
    if (cartsRequired) {
      return;
    }
    if (cartAmount < 0) {
      return;
    }
    setBookingState(prevState => {
      const ridingBySlot = normalizeRidingBySlotForCartAmount(
        prevState.ridingBySlot ?? [],
        cartAmount,
        prevState.golferAmount,
        true,
      );
      const bookingParticipants = prevState.bookingParticipants.map((participant, index) => {
        if (!participant || ridingBySlot[index] === undefined) {
          return participant;
        }
        return { ...participant, isRiding: ridingBySlot[index] };
      });

      return { ...prevState, powerCartAmount: cartAmount, ridingBySlot, bookingParticipants };
    });
  }

  function handleRemoveGolfers(newQuantity: number) {
    setBookingState(prevState => ({
      ...prevState,
      bookingParticipants: prevState.bookingParticipants.slice(0, newQuantity),
      ridingBySlot: prevState.ridingBySlot.slice(0, newQuantity),
      ...clearPlayerSearchFields(newQuantity),
    }));
  }

  async function returnToHomePage(deleteLock: boolean) {
    if (deleteLock) {
      const deleteLockTeeTimeRes = await DeleteLockTeeTime(true);

      if (deleteLockTeeTimeRes.status === StatusCode.OK) {
        dispatch(clientPortalUpdate({ selectedTeeTimeLock: null }));
      }
    }
    dispatch(clientPortalUpdate({ selectedTeeTime: null, postedBooking: null, initialQuantity: null }));
    history.push(HOME_URL);
  }

  function handleCheckboxChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { id, checked } = e.target;
    updateBookingState({ [id]: checked });
  }

  function handleAddPlayerCheckbox(participantId: number) {
    const addedPlayerIds = [...addFriendState.selectedPlayerIds];
    const foundIndex = addedPlayerIds?.indexOf(participantId);
    if (foundIndex === -1) {
      addedPlayerIds?.push(participantId);
    } else {
      addedPlayerIds?.splice(foundIndex, 1);
    }
    setAddFriendState(prevState => ({ ...prevState, selectedPlayerIds: addedPlayerIds }));
  }

  function disableCheckout() {
    //User hasn't accepted the payment terms and conditions
    if (!bookingState.acceptTerms) {
      return true;
    }
    // # of holes, # of players or # of power carts has not been selected
    if (!bookingState.holeAmount || !bookingState.golferAmount || bookingState.powerCartAmount == null) {
      return true;
    }

    // Cart is loading
    if (bookingState.loadPutCart || bookingState.cart === null) {
      return true;
    }

    //Credit card has not been selected
    if (creditCardRequired) {
      if (!paymentMethodState?.creditCard?.id) {
        return true;
      }
    }

    if (clientPortalStore?.selectedTeeTime?.bookings_prevent_guests) {
      if (bookingState?.bookingParticipants.length < bookingState.golferAmount) {
        return true;
      }
    }

    if (cartDriverUiEnabled) {
      const { minRiders, maxRiders } = getCartRiderConstraints(
        bookingState.powerCartAmount ?? 0,
        bookingState.golferAmount,
      );
      const assignedRiders = (bookingState.ridingBySlot ?? []).filter(value => value === true).length;
      if (assignedRiders < minRiders || assignedRiders > maxRiders) {
        return true;
      }
    }

    //Credit card has not been selected (payment required)
    if (clientPortalStore?.selectedTeeTime?.pre_paid_required && paymentDueState?.dueNow > 0) {
      if (!paymentMethodState?.creditCard?.id) {
        return true;
      }
    }

    //Payment option selected, but balance doesn't cover the full amount. Credit card must be selected to pay off remaining balance
    if (remainingAmount && remainingAmount > 0) {
      if (!paymentMethodState?.creditCard || !paymentMethodState?.cardPaymentOption) {
        return true;
      }
    }

    //Payment method has not been selected (payment required)
    if (clientPortalStore?.selectedTeeTime?.pre_paid_required && bookingState?.cart?.total_price_due > 0) {
      if (!paymentMethodState?.paymentOption && !paymentMethodState?.creditCard) {
        return true;
      }
    }

    if (
      paymentMethodState?.paymentOption?.payment_method === "gift_card" &&
      (!paymentMethodState?.giftCardCode || !paymentMethodState?.giftCardPin) &&
      !paymentMethodState?.creditCard
    ) {
      return true;
    }

    if (paymentMethodState?.paymentOption?.payment_method === "account" && !paymentMethodState?.accountId) {
      return true;
    }

    if (
      paymentMethodState?.paymentOption?.payment_method === "credit_book" &&
      !paymentMethodState?.creditBook?.id &&
      !paymentMethodState?.creditCard
    ) {
      return true;
    }

    if (paymentDueState?.dueNow && !paymentMethodState?.paymentOption && !paymentMethodState?.creditCard) {
      return true;
    }

    return false;
  }

  function disableHoles() {
    const tempHoleButtons = [true, true];
    const primaryCapacity = Number(clientPortalStore?.selectedTeeTime?.quantity_remaining ?? 0);
    // Split bookings only need enough turn capacity for the primary tee-time segment
    const primaryNeeded = Math.min(bookingState.golferAmount, primaryCapacity);

    // Disabling holes
    clientPortalStore?.selectedTeeTime?.divisions_available?.forEach(division => {
      // 9 holes available
      if (division === 1) {
        tempHoleButtons[1] = false;
      } else if (division === 2) {
        if (
          (clientPortalStore?.selectedTeeTime?.divisions_available?.length > 1 &&
            clientPortalStore?.selectedTeeTime?.turn_tee_time === null) ||
          isTurnBlockedForEighteenHoles(
            clientPortalStore?.selectedTeeTime?.turn_tee_time?.blocked_type,
            clientPortalStore?.selectedTeeTime?.blocked_type,
          ) ||
          ((clientPortalStore?.selectedTeeTime?.turn_tee_time?.league_id ||
            clientPortalStore?.selectedTeeTime?.turn_tee_time?.tournament_id) &&
            (clientPortalStore?.selectedTeeTime?.league_id !==
              clientPortalStore?.selectedTeeTime?.turn_tee_time?.league_id ||
              clientPortalStore?.selectedTeeTime?.tournament_id !==
              clientPortalStore?.selectedTeeTime?.turn_tee_time?.tournament_id)) ||
          (clientPortalStore.teeSheetSettings?.prevent_multiple_bookings &&
            clientPortalStore.selectedTeeTime?.turn_tee_time?.quantity_remaining !==
            clientPortalStore.selectedTeeTime?.turn_tee_time?.size)
        ) {
          // Only 9 holes available
          tempHoleButtons[1] = false;
        } else if (clientPortalStore?.selectedTeeTime?.turn_tee_time != null) {
          // 18 holes available for the primary segment (extras validated when prepared/posted)
          if (
            primaryNeeded > 0 &&
            clientPortalStore?.selectedTeeTime?.quantity_remaining >= primaryNeeded &&
            clientPortalStore?.selectedTeeTime?.turn_tee_time?.quantity_remaining >= primaryNeeded
          ) {
            tempHoleButtons[0] = false;
          } else {
            // Only 9 holes available
            tempHoleButtons[1] = false;
          }
        }
      }
    });

    if (tempHoleButtons[0] && tempHoleButtons[1]) {
      updateBookingState({ holeAmount: null });
    } else if (tempHoleButtons[0]) {
      updateBookingState({ holeAmount: 9 });
    } else if (tempHoleButtons[1]) {
      updateBookingState({ holeAmount: 18 });
    }
    setHoleButtons(tempHoleButtons);
    if (!loadingComplete) {
      setLoadingComplete(true);
    }
  }

  function getDepositAmount() {
    if (bookingState?.cart && bookingState?.cart?.line_items) {
      // Get total amount of green fees & power carts
      return bookingState?.cart?.line_items
        ?.filter(
          (lineItem: ICartLineItem & { product_type: string }) =>
            lineItem?.total_price > 0 && lineItem?.product_type !== "Booking Fee",
        )
        ?.reduce(
          (totalAmount: number, lineItem: ICartLineItem & { product_type: string }) =>
            lineItem?.total_price + totalAmount,
          0,
        ) as number;
    } else {
      return 0;
    }
  }

  function getBookingFeesTotal() {
    if (bookingState?.cart && bookingState?.cart?.line_items) {
      // Get total amount of green fees & power carts
      return bookingState?.cart?.line_items
        ?.filter(
          (lineItem: ICartLineItem & { product_type: string }) =>
            lineItem?.total_price > 0 && lineItem?.product_type === "Booking Fee",
        )
        ?.reduce(
          (totalAmount: number, lineItem: ICartLineItem & { product_type: string }) =>
            lineItem?.total_price + totalAmount,
          0,
        ) as number;
    } else {
      return 0;
    }
  }

  async function handlePayBookingDeposit() {
    let stripePaymentIntent = paymentState?.depositPaymentIntent;
    let depositClientSecret = paymentState?.depositClientSecret;
    let depositId = paymentState?.depositId;

    const depositAmount =
      clientPortalStore?.selectedTeeTime?.pre_paid_required || bookingState?.payNow
        ? getDepositAmount() // Full payment of green fees & power carts required (excluding booking fees)
        : bookingState?.cart?.deposit_amount; // Partial deposit required

    //POST Deposit
    if (paymentState?.depositStep <= DepositStep.post_deposit) {
      const postDepositRes = await PostCustomerBookingDeposit(
        {
          kind: "authorization",
          amount: depositAmount,
          facility_id: clientPortalStore?.selectedFacility?.id,
          customer_id: clientPortalStore?.user?.id,
        },
        false,
      );

      if (postDepositRes?.status !== StatusCode.OK || !postDepositRes?.data?.client_secret) {
        setPaymentState(prevState => ({ ...prevState, depositStep: DepositStep.post_deposit }));
        dispatch(showError(typeof postDepositRes?.data === "string" ? postDepositRes?.data : t("Deposit payment error")));
        dispatch(dequeue());
        return undefined;
      }
      const { id: depositID, client_secret: clientSecret } = postDepositRes.data;
      depositClientSecret = clientSecret;
      depositId = depositID;
    }

    //POST Stripe Card Payment
    if (paymentState?.depositStep <= DepositStep.confirm_stripe_payment) {
      //Confrim stripe card payment using user's credit card
      const { error: stripeError, paymentIntent } = await stripe.confirmCardPayment(depositClientSecret, {
        payment_method: paymentMethodState?.creditCard?.stripe_payment_method_id,
      });

      if (stripeError) {
        setPaymentState(prevState => ({
          ...prevState,
          depositClientSecret: depositClientSecret,
          depositId: depositId,
          depositStep: DepositStep.confirm_stripe_payment,
        }));
        dispatch(showError(stripeError.message));
        dispatch(dequeue());
        return undefined;
      }

      stripePaymentIntent = paymentIntent;
    }

    //PUT Capture Deposit
    if (paymentState?.depositStep <= DepositStep.put_capture) {
      //TODO: handle capture
      const depositCaptureRes = await PutCaptureCustomerBookingDeposit(
        { payment_intent_id: stripePaymentIntent?.id, deposit_id: depositId },
        false,
      );
      if (depositCaptureRes?.status !== StatusCode.OK) {
        setPaymentState(prev => ({
          ...prev,
          depositStep: DepositStep.put_capture,
          depositClientSecret: depositClientSecret,
          depositId: depositId,
          depositPaymentIntent: stripePaymentIntent,
        }));
        dispatch(
          showError(
            typeof depositCaptureRes?.data === "string" ? depositCaptureRes?.data : t("Deposit payment capture error"),
          ),
        );
        return undefined;
      }
    }

    //deposit success
    return depositId;
  }

  async function completeOrder(order: IOrder, depositId: number) {
    if (order) {
      //Complete Order
      const putCompleteOrderRes = await PutCompleteOrder({ token: order.token }, false);

      if (putCompleteOrderRes.status !== Number(StatusCode.OK)) {
        setPaymentState(prevState => ({
          ...prevState,
          step: PaymentStep.put_order_complete,
          order: order,
        }));
        dispatch(showError(t("Error completing order")));
        dispatch(dequeue());
        return;
      }

      //Order completed, create booking
      await postCustomerBooking(order, depositId);
    }
  }

  async function updateOrder(orderId: number, depositId: number) {
    if (orderId) {
      //Get updated order
      const orderRes = await GetOrder({ id: orderId, extended: true }, false);
      if (orderRes.status !== StatusCode.OK) {
        dispatch(showError(t("Error getting order")));
        return;
      }

      const order = orderRes?.data[0];

      //Order payed off, complete order and make booking
      if (order.balance <= 0 || order.financial_status === "paid") {
        await completeOrder(order as IOrder, depositId);
      } else {
        //Pay remaining balance with credit card

        if (!paymentMethodState?.creditCard) {
          ReactDOM.unstable_batchedUpdates(() => {
            setPaymentState(prevState => ({
              ...prevState,
              step: PaymentStep.post_transaction,
              order: order,
              depositId: depositId,
            }));
            setPaymentMethodState(prev => ({
              ...prev,
              paymentOption: null,
              giftCardBalance: null,
              giftCardCode: "",
              giftCardPin: "",
              creditBook: null,
              accountId: null,
            }));
          });
          dispatch(showError(t("Select a credit card to pay the remaining balance")));
          return;
        }

        //Process transaction
        const postTransactionRes = await PostTransactionNew(
          {
            order_token: order.token,
            kind: "authorization",
            amount: order?.balance ? Number(order?.balance?.toFixed(2)) : order?.total_price,
            payment_option_id: paymentMethodState?.cardPaymentOption?.id,
          },
          false,
        );

        const clientSecret = postTransactionRes?.data?.client_secret;
        const transactionId = postTransactionRes?.data?.id;

        if (postTransactionRes.status !== StatusCode.OK || !clientSecret) {
          setPaymentState(prevState => ({
            ...prevState,
            step: PaymentStep.post_transaction,
            order: order,
            depositId: depositId,
          }));
          dispatch(showError(t("Error creating transaction")));
          return;
        }

        //Confrim stripe card payment
        const { error: stripeError, paymentIntent } = await stripe.confirmCardPayment(clientSecret as string, {
          payment_method: paymentMethodState?.creditCard?.stripe_payment_method_id,
        });

        if (stripeError) {
          setPaymentState(prevState => ({
            ...prevState,
            step: PaymentStep.confirm_stripe_payment,
            order: order,
            clientSecret: clientSecret,
            transactionId: transactionId,
            depositId: depositId,
          }));
          dispatch(showError(stripeError.message));
          setPaymentMethodState(prev => ({
            ...prev,
            refreshPaymentMethods: true,
            paymentOption: null,
            giftCardBalance: null,
            giftCardCode: "",
            giftCardPin: "",
          })); //reload payment methods, remove used gift cards
          return;
        }
        const stripePaymentIntent = paymentIntent;

        //Capture card payment
        const putCaptureRes = await PutCapture(
          { payment_intent_id: stripePaymentIntent?.id, transaction_id: transactionId },
          false,
        );

        if (putCaptureRes.status !== StatusCode.OK) {
          setPaymentState(prevState => ({
            ...prevState,
            step: PaymentStep.put_capture,
            order: order,
            clientSecret: clientSecret,
            transactionId: transactionId,
            paymentIntent: stripePaymentIntent,
            depositId: depositId,
          }));
          dispatch(showError(t("Card capture error")));
          setPaymentMethodState(prev => ({
            ...prev,
            refreshPaymentMethods: true,
            paymentOption: null,
            giftCardBalance: null,
            giftCardCode: "",
            giftCardPin: "",
          })); //reload payment methods, remove used gift cards
          return;
        }

        //Complete order and make booking
        await completeOrder(order as IOrder, depositId);
      }
    }
  }

  async function validateBooking() {
    const customerIds = setCustomerIds();
    const cartDrivers =
      cartDriverUiEnabled
        ? customerIds.map((_, index) => bookingState.ridingBySlot?.[index] === true)
        : undefined;

    const primaryCapacity = Number(clientPortalStore?.selectedTeeTime?.quantity_remaining ?? 0);
    const extraPlayersSlots = bookingState.extraPlayersSlots ?? [];
    const primaryQuantity =
      extraPlayersSlots.length > 0
        ? Math.min(bookingState.golferAmount, primaryCapacity)
        : bookingState.golferAmount;

    let remainingPowerCarts = bookingState.powerCartAmount;
    const segments: Array<{
      tee_time_id: number;
      quantity: number;
      power_cart_quantity: number;
      customerOffset: number;
    }> = [
      {
        tee_time_id: clientPortalStore?.selectedTeeTime?.id,
        quantity: primaryQuantity,
        power_cart_quantity: Math.min(remainingPowerCarts, 2),
        customerOffset: 0,
      },
    ];
    remainingPowerCarts = Math.max(0, remainingPowerCarts - segments[0].power_cart_quantity);

    let customerOffset = primaryQuantity;
    for (const extra of extraPlayersSlots) {
      const powerCartQuantity = Math.min(remainingPowerCarts, 2);
      remainingPowerCarts = Math.max(0, remainingPowerCarts - powerCartQuantity);
      segments.push({
        tee_time_id: extra.tee_time_id,
        quantity: extra.quantity,
        power_cart_quantity: powerCartQuantity,
        customerOffset,
      });
      customerOffset += extra.quantity;
    }

    for (const segment of segments) {
      const segmentCustomerIds = customerIds.slice(segment.customerOffset, segment.customerOffset + segment.quantity);
      while (segmentCustomerIds.length < segment.quantity) {
        segmentCustomerIds.push(clientPortalStore?.user?.id);
      }
      const segmentCartDrivers = cartDrivers
        ? cartDrivers.slice(segment.customerOffset, segment.customerOffset + segment.quantity)
        : undefined;
      const segmentNames = bookingState.allowGuestNames
        ? setCustomerNames().slice(segment.customerOffset, segment.customerOffset + segment.quantity)
        : undefined;

      const params = {
        tee_time_id: segment.tee_time_id,
        holes: bookingState.holeAmount,
        quantity: segment.quantity,
        power_cart_quantity: segment.power_cart_quantity,
        customer_payment_method_id:
          clientPortalStore?.selectedTeeTime?.pre_paid_required ||
          bookingState?.cart?.booking_fee_required ||
          creditCardRequired
            ? paymentMethodState?.creditCard?.id
            : null,
        accept_payment_terms: bookingState.acceptTerms,
        customer_ids: segmentCustomerIds,
        customers_riding: segmentCartDrivers,
        customer_names: segmentNames,
      };

      const bookingRes = await PutValidateCustomerBooking(params, true);
      if (bookingRes.status !== StatusCode.OK) {
        dispatch(dequeue());
        let bookingErrorMessage = String(t("Error creating booking"));
        if (typeof bookingRes.data === "string") {
          bookingErrorMessage = bookingRes.data;
        } else if (typeof bookingRes.data?.message === "string") {
          bookingErrorMessage = bookingRes.data.message;
        }
        dispatch(showError(bookingErrorMessage));
        return false;
      }
    }
    return true;
  }

  async function processPayment() {
    //Show loader
    dispatch(enqueue());

    let order = paymentState?.order;
    let currentCartToken = paymentState?.cartToken;
    let clientSecret = paymentState?.clientSecret;
    let transactionId = paymentState?.transactionId;
    let stripePaymentIntent = paymentState?.paymentIntent;
    let depositId = paymentState?.depositId;

    const isPrepaid = clientPortalStore?.selectedTeeTime?.pre_paid_required;
    const deposit = bookingState?.cart?.total_price === 0 ? 0 : bookingState?.cart?.deposit_amount ?? 0;
    const total = bookingState?.cart?.total_price?.toFixed(2) ?? 0;
    const depositApplies =
      ((isPrepaid || bookingState?.payNow) && getDepositAmount() > 0) ||
      (bookingState?.payAtCourse && deposit > 0 && deposit < total);
    const amountDueNow = depositApplies
      ? isPrepaid || bookingState?.payNow
        ? getBookingFeesTotal()
        : Math.max(paymentDueState?.dueNow - deposit, 0)
      : paymentDueState?.dueNow;

    const bookingValidated = await validateBooking();
    // Booking cannot be made, cancel booking/payment process
    if (!bookingValidated) {
      return;
    }

    ///Booking deposit or prepaid tee time
    if (depositApplies && paymentState.depositStep < DepositStep.complete) {
      depositId = await handlePayBookingDeposit();
      if (!depositId) {
        //Deposit wasn't successful, don't continue with booking process
        return;
      }
    }

    //Payment required
    if ((amountDueNow > 0 || (deposit > 0 && deposit >= total)) && paymentState?.step < PaymentStep.post_booking) {
      try {
        //Order doesn't exist, create the cart and order
        if (!order) {
          //Create payment cart
          setPrepaidWarning(prevState => ({ ...prevState, open: false }));
          if (paymentState.step <= PaymentStep.post_line_item) {
            const cartRes = await PostCart(
              {
                sales_channel: "booking_engine",
                facility_id: clientPortalStore?.selectedFacility?.id,
                customer_id: clientPortalStore?.user?.id,
              },
              false,
            );
            if (cartRes.status !== Number(StatusCode.OK)) {
              setPaymentState(prevState => ({
                ...prevState,
                step: PaymentStep.post_cart,
                depositStep: depositId ? DepositStep.complete : prevState.depositStep,
                depositId: depositId,
              }));
              dispatch(showError(t("Error creating cart")));
              dispatch(dequeue());
              return;
            }

            currentCartToken = cartRes?.data?.token;
          }

          if (paymentState.step <= PaymentStep.post_line_item) {
            //Add prepaid line items to the new cart
            for (const lineItem of bookingState.cart.line_items) {
              const isBookingFee = lineItem?.product_type === "Booking Fee";
              // const isPrepaidTeeTime = isPrepaid;
              // const payNowLineItem = bookingState?.payNow;
              // const addLineItem = isBookingFee || isPrepaidTeeTime || payNowLineItem || deposit >= total;
              const addLineItem = isBookingFee;

              //Add line items
              if (!addLineItem) {
                continue;
              }
              const postLineItemRes = await PostLineItemToCart(
                { variant_id: lineItem?.variant_id, cart_token: currentCartToken, quantity: lineItem?.quantity },
                false,
              );
              if (postLineItemRes?.status !== Number(StatusCode.OK)) {
                setPaymentState(prevState => ({
                  ...prevState,
                  step: PaymentStep.post_line_item,
                  cartToken: currentCartToken,
                  depositStep: depositId ? DepositStep.complete : prevState.depositStep,
                  depositId: depositId,
                }));
                dispatch(showError(t("Error adding line item to cart")));
                dispatch(dequeue());
                return;
              }
            }
          }

          if (paymentState?.step <= PaymentStep.post_checkout) {
            const postCheckoutRes = await PostCheckout({ cart_token: currentCartToken }, false);
            if (postCheckoutRes.status !== Number(StatusCode.OK)) {
              setPaymentState(prevState => ({
                ...prevState,
                step: PaymentStep.post_checkout,
                cartToken: currentCartToken,
                depositStep: depositId ? DepositStep.complete : prevState.depositStep,
                depositId: depositId,
              }));
              dispatch(showError(t("Checkout error")));
              dispatch(dequeue());
              return;
            }
            order = postCheckoutRes.data?.order;

            if (!order?.token) {
              setPaymentState(prevState => ({
                ...prevState,
                step: PaymentStep.post_checkout,
                cartToken: currentCartToken,
                depositStep: depositId ? DepositStep.complete : prevState.depositStep,
                depositId: depositId,
              }));
              dispatch(showError(t("Order does not exist")));
              dispatch(dequeue());
              return;
            }
          }
        }

        if (
          paymentMethodState?.paymentOption?.payment_method === "gift_card" &&
          paymentMethodState?.giftCardPin &&
          paymentMethodState?.giftCardCode
        ) {
          //Gift card payment
          const transactionRes = await PostTransactionNew(
            {
              kind: "sale",
              amount: order?.balance ? Number(order?.balance?.toFixed(2)) : order?.total_price,
              order_token: order?.token,
              payment_option_id: paymentMethodState?.paymentOption?.id,
              gift_card_code: paymentMethodState?.giftCardCode,
              gift_card_pin: paymentMethodState?.giftCardPin,
            },
            false,
          );
          if (transactionRes.status !== StatusCode.OK) {
            setPaymentState(prevState => ({
              ...prevState,
              step: PaymentStep.post_transaction,
              cartToken: currentCartToken,
              order: order,
              depositStep: depositId ? DepositStep.complete : prevState.depositStep,
              depositId: depositId,
            }));
            dispatch(
              showError(
                typeof transactionRes?.data === "string" ? transactionRes?.data : t("Error creating transaction"),
              ),
            );
            dispatch(dequeue());
            return;
          }

          setPaymentState(prevState => ({
            ...prevState,
            step: PaymentStep.put_order_complete,
            cartToken: currentCartToken,
            order: order,
            clientSecret: clientSecret,
            transactionId: transactionId,
            paymentIntent: stripePaymentIntent,
            depositStep: depositId ? DepositStep.complete : prevState.depositStep,
            depositId: depositId,
          }));

          await updateOrder(transactionRes?.data?.order_id as number, depositId);
          dispatch(dequeue());
        } else if (paymentMethodState?.paymentOption?.payment_method === "account" && paymentMethodState?.accountId) {
          //House account payment
          const transactionRes = await PostTransactionNew(
            {
              kind: "sale",
              amount: order?.balance ? Number(order?.balance?.toFixed(2)) : order?.total_price,
              order_token: order?.token,
              payment_option_id: paymentMethodState?.paymentOption?.id,
              account_id: paymentMethodState?.accountId,
            },
            false,
          );

          if (transactionRes.status !== StatusCode.OK) {
            setPaymentState(prevState => ({
              ...prevState,
              step: PaymentStep.post_transaction,
              cartToken: currentCartToken,
              order: order,
              depositStep: depositId ? DepositStep.complete : prevState.depositStep,
              depositId: depositId,
            }));
            dispatch(
              showError(
                typeof transactionRes?.data === "string" ? transactionRes?.data : t("Error creating transaction"),
              ),
            );
            dispatch(dequeue());
            return;
          }

          setPaymentState(prevState => ({
            ...prevState,
            step: PaymentStep.put_order_complete,
            cartToken: currentCartToken,
            order: order,
            clientSecret: clientSecret,
            transactionId: transactionId,
            paymentIntent: stripePaymentIntent,
            depositStep: depositId ? DepositStep.complete : prevState.depositStep,
            depositId: depositId,
          }));

          await updateOrder(transactionRes?.data?.order_id as number, depositId);
          dispatch(dequeue());
        } else if (
          paymentMethodState?.paymentOption?.payment_method === "credit_book" &&
          paymentMethodState?.creditBook
        ) {
          //Credit book payment
          const transactionRes = await PostTransactionNew(
            {
              kind: "sale",
              amount: order?.balance ? Number(order?.balance?.toFixed(2)) : order?.total_price,
              order_token: order?.token,
              payment_option_id: paymentMethodState?.paymentOption?.id,
              credit_book_id: paymentMethodState?.creditBook?.id,
            },
            false,
          );

          if (transactionRes.status !== StatusCode.OK) {
            setPaymentState(prevState => ({
              ...prevState,
              step: PaymentStep.post_transaction,
              cartToken: currentCartToken,
              order: order,
              depositStep: depositId ? DepositStep.complete : prevState.depositStep,
            }));
            dispatch(
              showError(
                typeof transactionRes?.data === "string" ? transactionRes?.data : t("Error creating transaction"),
              ),
            );
            dispatch(dequeue());
            return;
          }

          setPaymentState(prevState => ({
            ...prevState,
            step: PaymentStep.put_order_complete,
            cartToken: currentCartToken,
            order: order,
            clientSecret: clientSecret,
            transactionId: transactionId,
            paymentIntent: stripePaymentIntent,
            depositStep: depositId ? DepositStep.complete : prevState.depositStep,
            depositId: depositId,
          }));

          await updateOrder(transactionRes?.data?.order_id as number, depositId);
          dispatch(dequeue());
        } else {
          //Credit card payment

          if (!paymentMethodState?.creditCard) {
            dispatch(showError(t("Credit card selection is required")));
            dispatch(dequeue());
            setPaymentState(prevState => ({
              ...prevState,
              cartToken: currentCartToken,
              order: order,
              depositStep: depositId ? DepositStep.complete : prevState.depositStep,
              depositId: depositId,
            }));
            return;
          }

          //Process transaction
          const postTransactionRes = await PostTransactionNew(
            {
              order_token: order.token,
              kind: "authorization",
              amount: order?.balance ? Number(order?.balance?.toFixed(2)) : order?.total_price,
              payment_option_id: paymentMethodState?.cardPaymentOption?.id,
            },
            false,
          );

          clientSecret = postTransactionRes?.data?.client_secret;
          transactionId = postTransactionRes?.data?.id;

          if (postTransactionRes.status !== StatusCode.OK || !clientSecret) {
            setPaymentState(prevState => ({
              ...prevState,
              step: PaymentStep.post_transaction,
              cartToken: currentCartToken,
              order: order,
              depositStep: depositId ? DepositStep.complete : prevState.depositStep,
              depositId: depositId,
            }));
            dispatch(showError(t("Error creating transaction")));
            dispatch(dequeue());
            return;
          }

          //Confrim stripe card payment
          const { error: stripeError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
            payment_method: paymentMethodState?.creditCard?.stripe_payment_method_id,
          });

          if (stripeError) {
            setPaymentState(prevState => ({
              ...prevState,
              step: PaymentStep.confirm_stripe_payment,
              cartToken: currentCartToken,
              order: order,
              clientSecret: clientSecret,
              transactionId: transactionId,
              depositStep: depositId ? DepositStep.complete : prevState.depositStep,
              depositId: depositId,
            }));
            dispatch(showError(stripeError.message));
            dispatch(dequeue());
            return;
          }
          stripePaymentIntent = paymentIntent;

          //Capture card payment
          const putCaptureRes = await PutCapture(
            { payment_intent_id: stripePaymentIntent?.id, transaction_id: transactionId },
            false,
          );

          if (putCaptureRes.status !== StatusCode.OK) {
            setPaymentState(prevState => ({
              ...prevState,
              step: PaymentStep.put_capture,
              cartToken: currentCartToken,
              order: order,
              clientSecret: clientSecret,
              transactionId: transactionId,
              paymentIntent: stripePaymentIntent,
              depositStep: depositId ? DepositStep.complete : prevState.depositStep,
              depositId: depositId,
            }));
            dispatch(showError(t("Card capture error")));
            dispatch(dequeue());
            return;
          }

          setPaymentState(prevState => ({
            ...prevState,
            step: PaymentStep.put_order_complete,
            cartToken: currentCartToken,
            order: order,
            clientSecret: clientSecret,
            transactionId: transactionId,
            paymentIntent: stripePaymentIntent,
            depositStep: depositId ? DepositStep.complete : prevState.depositStep,
            depositId: depositId,
          }));

          await updateOrder(postTransactionRes?.data?.order_id as number, depositId);
          dispatch(dequeue());
        }
      } catch (e) {
        console.error(e);
        dispatch(dequeue());
      }
    } else {
      dispatch(dequeue());
      // Payment not required, create the booking
      await postCustomerBooking(order, depositId);
    }
  }

  async function postCustomerBooking(order: IOrder, depositId?: number) {
    if (
      !bookingState.acceptTerms ||
      !bookingState.holeAmount ||
      !bookingState.golferAmount ||
      bookingState.powerCartAmount == null
    ) {
      console.log("Booking error, missing holes, players or power cart amount. User may not have accepted terms.");
      return;
    }

    if (creditCardRequired && !paymentMethodState?.creditCard) {
      console.log("Booking error, missing payment information.");
      return;
    }

    const lockAllOptions = order && bookingState?.cart?.pre_paid_required ? true : false;
    const lockQuantity =
      order && !bookingState?.cart?.pre_paid_required && bookingState?.cart?.booking_fee_required ? true : false;

    const customerIds = setCustomerIds();
    const cartDrivers = cartDriverUiEnabled
      ? customerIds.map((_, index) => bookingState.ridingBySlot?.[index] === true)
      : undefined;

    const isPrepaid = clientPortalStore?.selectedTeeTime?.pre_paid_required;
    //Determines if prepaid amount covers green fees & power carts
    const prepaidDepositApplies = (isPrepaid || bookingState?.payNow) && getDepositAmount() > 0;

    const primaryCapacity = Number(clientPortalStore?.selectedTeeTime?.quantity_remaining ?? 0);
    const extraPlayersSlots = bookingState.extraPlayersSlots ?? [];
    const primaryQuantity =
      extraPlayersSlots.length > 0 ? Math.min(bookingState.golferAmount, primaryCapacity) : bookingState.golferAmount;
    const primaryCustomerIds = customerIds.slice(0, primaryQuantity);
    const primaryCartDrivers = cartDrivers ? cartDrivers.slice(0, primaryQuantity) : undefined;

    let remainingPowerCarts = bookingState.powerCartAmount;
    const primaryPowerCartQuantity = Math.min(remainingPowerCarts, 2);
    remainingPowerCarts = Math.max(0, remainingPowerCarts - primaryPowerCartQuantity);

    const paymentMethodId =
      order ||
        clientPortalStore?.selectedTeeTime?.pre_paid_required ||
        bookingState?.cart?.booking_fee_required ||
        creditCardRequired
        ? paymentMethodState?.creditCard?.id
        : null;

    const params = {
      tee_time_id: clientPortalStore?.selectedTeeTime?.id,
      holes: bookingState.holeAmount,
      quantity: primaryQuantity,
      power_cart_quantity: primaryPowerCartQuantity,
      customer_payment_method_id: paymentMethodId,
      accept_payment_terms: bookingState.acceptTerms,
      accept_marketing_email: bookingState.acceptMarketingEmail,
      cart_token: bookingState.cart?.token,
      // Only attach order_id when green fees are paid online. Booking-fee-only
      // checkouts must not mark participants as paid (blocks ticket redemption).
      order_id:
        order &&
        (bookingState?.cart?.pre_paid_required ||
          clientPortalStore?.selectedTeeTime?.pre_paid_required ||
          bookingState?.payNow)
          ? order.id
          : undefined,
      booking_fee_order_id: order && bookingState?.cart?.booking_fee_required ? order?.id : undefined,
      lock_quantity: lockAllOptions || lockQuantity,
      lock_holes: lockAllOptions,
      lock_power_cart_quantity: lockAllOptions,
      customer_ids: primaryCustomerIds,
      customers_riding: primaryCartDrivers,
      waitlist_reference_id: clientPortalStore?.waitlist_reference_id ?? undefined,
      customer_names: bookingState.allowGuestNames ? setCustomerNames().slice(0, primaryQuantity) : undefined,
      deposit_id: depositId ? depositId : undefined,
      source: "online",
      pre_paid: prepaidDepositApplies ? true : false,
    };

    const bookingRes = await PostCustomerBooking(params, true);
    if (bookingRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error creating booking")));
      return;
    }

    let customerIdOffset = primaryQuantity;
    for (const extra of extraPlayersSlots) {
      const extraPowerCartQuantity = Math.min(remainingPowerCarts, 2);
      remainingPowerCarts = Math.max(0, remainingPowerCarts - extraPowerCartQuantity);
      const extraCustomerIds = customerIds.slice(customerIdOffset, customerIdOffset + extra.quantity);
      while (extraCustomerIds.length < extra.quantity) {
        extraCustomerIds.push(clientPortalStore?.user?.id);
      }
      const extraCartDrivers = cartDrivers
        ? cartDrivers.slice(customerIdOffset, customerIdOffset + extra.quantity)
        : undefined;

      const extraBookingRes = await PostCustomerBooking(
        {
          tee_time_id: extra.tee_time_id,
          holes: bookingState.holeAmount,
          quantity: extra.quantity,
          power_cart_quantity: extraPowerCartQuantity,
          customer_payment_method_id: paymentMethodId,
          accept_payment_terms: bookingState.acceptTerms,
          accept_marketing_email: bookingState.acceptMarketingEmail,
          cart_token: undefined,
          order_id: undefined,
          booking_fee_order_id: undefined,
          lock_quantity: lockAllOptions || lockQuantity,
          lock_holes: lockAllOptions,
          lock_power_cart_quantity: lockAllOptions,
          customer_ids: extraCustomerIds,
          customers_riding: extraCartDrivers,
          source: "online",
          pre_paid: prepaidDepositApplies ? true : false,
          deposit_id: depositId ? depositId : undefined,
          booking_group_id: bookingRes.data?.booking_group_id,
          customer_names: bookingState.allowGuestNames
            ? setCustomerNames().slice(customerIdOffset, customerIdOffset + extra.quantity)
            : undefined,
        },
        true,
      );

      if (extraBookingRes.status !== StatusCode.OK) {
        dispatch(showError(t("Error creating booking")));
        return;
      }

      customerIdOffset += extra.quantity;
    }

    if (bookingState?.note && bookingState?.note?.length > 0) {
      const res = await PostCustomerBookingNote(
        {
          tee_time_booking_id: bookingRes?.data?.id,
          content: bookingState?.note,
          tee_time_booking_participant_id: bookingRes?.data?.participants[0]?.id,
        },
        true,
      );
      if (res?.status !== StatusCode.OK) {
        dispatch(showError(t("Error setting booking note")));
      }
    }

    if (clientPortalStore?.currentRwgToken) {
      const conversionRes = await PostRWGTokenConversion(
        {
          conversion_partner_id: "20003648",
          rwg_token_id: clientPortalStore?.currentRwgToken?.id,
          merchant_changed:
            clientPortalStore?.currentRwgToken?.facility_id === clientPortalStore?.selectedFacility?.id ? 2 : 1,
        },
        false,
      );
      if (conversionRes.status !== StatusCode.OK) {
        dispatch(showError(t("Error converting RWG token")));
      }
    }

    dispatch(
      clientPortalUpdate({
        postedBooking: {
          ...bookingRes.data,
          paymentMethodId: paymentMethodState?.creditCard?.id ?? null,
          cart: { ...bookingRes?.data?.cart, deposit_amount: bookingState?.cart?.deposit_amount },
        },
        selectedTeeTimeLock: null,
        waitlist_reference_id: null,
        initialQuantity: null,
      }),
    );

    const bookingToken = bookingRes.data?.token as string;

    // Load grouped bookings so the confirmation page can show every tee time
    if (bookingRes.data?.booking_group_id || extraPlayersSlots.length > 0) {
      const groupBookingRes = await GetBooking(
        { token: bookingToken, extended: true, group_bookings: true, turn_tee_time: true },
        true,
      );
      if (groupBookingRes.status === StatusCode.OK && groupBookingRes.data?.[0]) {
        dispatch(
          clientPortalUpdate({
            postedBooking: {
              ...groupBookingRes.data[0],
              paymentMethodId: paymentMethodState?.creditCard?.id ?? null,
              cart: {
                ...(groupBookingRes.data[0]?.cart ?? bookingRes?.data?.cart),
                deposit_amount: bookingState?.cart?.deposit_amount,
              },
            },
          }),
        );
      }
    }

    localStorage.removeItem(
      `${clientShortName}_${clientPortalStore?.selectedFacility?.short_name}_booking_engine_cart_token`,
    );
    const address = `/portal/${clientShortName}/confirm?token=${bookingToken}&facility=${clientPortalStore?.selectedFacility?.short_name}`;
    history.push(address);
  }

  function setCustomerIds() {
    const customerIds: number[] = [];
    for (let index = 0; index < bookingState.golferAmount; index++) {
      const participantId = bookingState?.bookingParticipants?.[index]?.customer_id;
      customerIds.push(participantId ?? clientPortalStore?.user?.id);
    }
    return customerIds;
  }

  function setCustomerNames() {
    const names: string[] = [""];
    for (let slot = 2; slot <= bookingState.golferAmount; slot++) {
      names.push(String(bookingState[`player${slot}`] ?? ""));
    }
    return names;
  }

  async function checkFriendsToAdd() {
    //Skip adding friends for leagues
    if (!clientPortalStore?.selectedTeeTime?.league_id && !friendsAdded) {
      //Display modal to add playing partners that are not in the user's friends list
      const newPlayingPartners = bookingState?.bookingParticipants?.filter(
        participant =>
          participant?.customer_id !== clientPortalStore?.user?.id &&
          !bookingState?.friendsList?.some(friend => friend?.id === participant?.id),
      );
      if (newPlayingPartners?.length > 0) {
        const addedPlayers = newPlayingPartners?.map(partner => partner?.customer_id);
        setAddFriendState(prevState => ({
          ...prevState,
          friendsToAdd: newPlayingPartners,
          modalVisible: true,
          selectedPlayerIds: addedPlayers,
        }));
        return;
      }
    }
    //Make booking if there are no users in the booking that are outside of the user's friends list
    await processPayment();
  }

  async function handleAddFriends() {
    const usersToAdd = [...addFriendState.selectedPlayerIds];
    if (usersToAdd?.length > 0) {
      const addRes = await PostFriends({ friend_user_ids: usersToAdd }, true);
      if (addRes?.status !== StatusCode.OK) {
        dispatch(showError(t("Error adding playing partners")));
      } else {
        dispatch(showSuccess(t("Successfully added playing partners")));
      }
    }
    ReactDOM.unstable_batchedUpdates(() => {
      setFriendsAdded(true);
      setAddFriendState(prevState => ({
        ...prevState,
        modalVisible: false,
      }));
    });

    await processPayment();
  }

  function removeGolferFromBooking(index: number) {
    const participants = [...bookingState.bookingParticipants];
    participants.splice(index, 1);
    const cartsRequiredDefaults = cartsRequired ? applyCartsRequiredState(bookingState.golferAmount) : null;
    let slots = [...bookingState.ridingBySlot];
    slots.splice(index, 1);
    if (cartsRequiredDefaults) {
      slots = cartsRequiredDefaults.ridingBySlot;
    } else {
      while (slots.length < bookingState.golferAmount) {
        slots.push(bookingState.powerCartAmount > 0 ? false : null);
      }
    }
    ReactDOM.unstable_batchedUpdates(() => {
      setBookingState(prevState => ({
        ...prevState,
        bookingParticipants: participants,
        powerCartAmount: cartsRequiredDefaults?.powerCartAmount ?? prevState.powerCartAmount,
        ridingBySlot: slots,
        ...clearPlayerSearchFields(prevState.golferAmount),
      }));
    });
  }

  const handleCustomerSearch = (query: string, name: string) => {
    setBookingState(prevState => ({ ...prevState, [name]: query }));
  };

  function handleCustomerSelection(id: number, friend: Partial<IBookingParticipant>) {
    const updatedBookingParticipants = [...bookingState.bookingParticipants];
    updatedBookingParticipants.push({ ...friend, customer_id: friend?.id });
    setBookingState(prevState => ({
      ...prevState,
      bookingParticipants: updatedBookingParticipants,
      selectedNewPlayer: null,
      addPlayerModalVisible: false,
      newPlayerQuery: "",
      customerSearchResult: [],
      ...clearPlayerSearchFields(prevState.golferAmount),
    }));
  }

  function handleLeagueParticipantSelection(id: number, participant: Record<string, any>) {
    const updatedBookingParticipants = [...bookingState.bookingParticipants];
    updatedBookingParticipants.push({
      ...participant,
      customer_id: participant?.user_id,
      full_name: participant?.customer?.full_name,
    });
    setBookingState(prevState => {
      const clearedQueries: Record<string, string> = {};
      for (let slot = 1; slot <= prevState.golferAmount; slot++) {
        clearedQueries[`leagueParticipantQuery_${slot}`] = "";
      }
      return {
        ...prevState,
        bookingParticipants: updatedBookingParticipants,
        ...clearedQueries,
      };
    });
  }

  function displayAddPlayerModal() {
    setBookingState(prevState => ({
      ...prevState,
      addPlayerModalVisible: !prevState.addPlayerModalVisible,
      selectedNewPlayer: null,
      newPlayerQuery: "",
      customerSearchResult: [],
    }));
  }

  function renderFriendsList(playerSearchResult: string) {
    //Display the search results if the array contains values
    if (bookingState[playerSearchResult]?.length > 0) {
      const guestsList: Array<ICustomerFriend> = bookingState[playerSearchResult];
      return guestsList.filter(
        guests => !bookingState.bookingParticipants.some(participants => participants.customer_id === guests.id),
      );
    } else {
      //Else return the entire friends list
      return bookingState.friendsList.filter(
        guests => !bookingState.bookingParticipants.some(participants => participants.customer_id === guests.id),
      );
    }
  }

  function handleNewPlayerSelection(id: string, friend: any) {
    setBookingState(prevState => ({ ...prevState, selectedNewPlayer: friend }));
  }

  function removeNewPlayerSelection() {
    setBookingState(prevState => ({ ...prevState, selectedNewPlayer: null, newPlayerQuery: "" }));
  }

  function displayBookingFeeWarning() {
    setPrepaidWarning(prevState => ({
      ...prevState,
      open: true,
      title: t("Booking Fee Charge"),
      description: t(
        "This tee time has non refundable booking fees that will be charged to your selected payment method. Do you wish to continue with this booking?",
      ),
    }));
  }

  function displayPrePaidWarning() {
    setPrepaidWarning(prevState => ({
      ...prevState,
      open: true,
      title: t("Pre Paid Charge"),
      description: t(
        "This tee time is pre paid and your selected payment method will be charged. Do you wish to continue?",
      ),
    }));
  }

  function searchLeagueParticipant(searchString: string, index: number) {
    setBookingState(prevState => ({ ...prevState, [`leagueParticipantQuery_${index + 1}`]: searchString }));
  }

  function displayTerms(e: React.MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    updateBookingState({ paymentTermsActive: true });
  }

  async function getGiftCardBalance() {
    //loader
    if (paymentMethodState?.giftCardBalance !== undefined) {
      setPaymentMethodState(prev => ({ ...prev, giftCardBalance: undefined }));
    }

    const res = await GetGuestGiftCardBalance(
      { code: paymentMethodState?.giftCardCode, pin: paymentMethodState?.giftCardPin },
      false,
    );
    if (res?.status !== StatusCode.OK) {
      dispatch(showError(t("Gift card is not valid. Please check your code and pin and try again")));
      setPaymentMethodState(prev => ({ ...prev, giftCardBalance: null }));
      return false;
    }
    if (res?.data <= 0) {
      dispatch(showError(t("Gift card balance is 0")));
      setPaymentMethodState(prev => ({ ...prev, giftCardBalance: null }));
      return false;
    }

    setPaymentMethodState(prev => ({ ...prev, giftCardBalance: res?.data }));
    return true;
  }

  const bookingFeePaid =
    (paymentState?.step > PaymentStep.put_order_complete &&
      paymentState?.step <= PaymentStep.post_booking &&
      bookingState?.cart?.total_price_due) ||
    !!paymentState?.order;

  //Amount remaining after selecting a gift card / credit book (potentially only covers a partial amount of the order)
  const remainingAmount = paymentMethodState?.creditBook
    ? paymentDueState?.dueNow - paymentMethodState?.creditBook?.balance
    : paymentMethodState?.giftCardBalance
      ? paymentDueState?.dueNow - paymentMethodState?.giftCardBalance
      : undefined;

  return (
    activeUser &&
    loadingComplete && (
      <>
        <div className="client-portal-booking-background">
          <ClientPortalNavigation />
          <div className="client-portal-booking-timer-container">
            <div className="client-portal-booking-timer-facility-container">
              <span className="client-portal-booking-timer-course-logo">
                {clientPortalStore?.selectedFacility?.logo_source && (
                  <img
                    className="client-portal-booking-timer-course-logo"
                    src={clientPortalStore?.selectedFacility?.logo_source}
                    alt={t("Facility Logo")}
                  />
                )}
              </span>
              <div className="flex flex-col gap-1">
                <p className="client-portal-booking-timer-course-name">
                  {clientPortalStore?.selectedFacility?.long_name}
                </p>
                {clientPortalStore?.selectedFacility && (
                  <p className="client-portal-booking-timer-address">{`${clientPortalStore?.selectedFacility?.address_line_1}, ${clientPortalStore?.selectedFacility?.city}, ${clientPortalStore?.selectedFacility?.province_name}, ${clientPortalStore?.selectedFacility?.postal}`}</p>
                )}
              </div>
            </div>
            <div className="client-portal-booking-timer-duration-container">
              <FontAwesomeIcon className="client-portal-booking-timer-icon" size="1x" color="#999999" icon={faClock} />
              <span className="client-portal-booking-timer-address">{"Time left to complete booking:"}</span>
              <span className="client-portal-booking-timer-duration-countdown">
                <BookingTimer
                  expireTime={clientPortalStore?.selectedTeeTimeLock?.expireTime}
                  teeTimeExpiryUrl={HOME_URL}
                  active={true}
                />
              </span>
            </div>
          </div>
          <div className="client-portal-booking-main-container">
            <div className="client-portal-booking-main-container-left-side">
              <Card>
                <Card.Section>
                  {clientPortalStore?.selectedTeeTime?.is_restricted && displayRestricted ? (
                    <>
                      <Callout
                        type={"error"}
                        title={t("Your member rate is restricted for this tee time")}
                        content={t("By continuing booking, you will pay the regular fee rate.")}
                        actions={{
                          primary: {
                            label: t("Continue with regular fee"),
                            onClick: () => setDisplayRestricted(false),
                            buttonType: "error",
                          },
                          secondary: { label: t("Choose a different tee time"), onClick: () => returnToHomePage(true) },
                        }}
                      />{" "}
                      <br />
                    </>
                  ) : null}
                  <p
                    className={
                      teeTimeHasPromotion
                        ? "client-portal-booking-booking-details-selection-start-time client-portal-booking-booking-details-selection-start-time--promotion"
                        : "client-portal-booking-booking-details-selection-start-time"
                    }
                  >
                    {teeTimeHasPromotion ? (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="booking-tee-time-promotion">
                            {clientPortalStore?.selectedTeeTime?.promotion_label || t("Promotion")}
                          </Tooltip>
                        }
                      >
                        <FontAwesomeIcon className="client-portal-booking-promotion-icon" icon={faTag} />
                      </OverlayTrigger>
                    ) : null}
                    {moment(clientPortalStore?.selectedTeeTime?.start_time, "hh:mm:ss").format("h:mm A")}
                  </p>
                  <p className="client-portal-booking-booking-details-selection-date">
                    {clientPortalStore?.selectedTeeTime?.formattedDate}
                  </p>

                  {clientPortalStore?.teeSheetSettings?.display_divisions_online &&
                  clientPortalStore?.selectedTeeTime?.division_title ? (
                    <div className="client-portal-booking-booking-details-selection-division">
                      <Badge size="small" type="gray">
                        {clientPortalStore.selectedTeeTime.division_title}
                        {bookingState.holeAmount === 18 &&
                        clientPortalStore.selectedTeeTime.turn_division_title ? (
                          <>
                            <FontAwesomeIcon icon={["far", "long-arrow-right"]} className="mr-1 ml-1" />
                            {clientPortalStore.selectedTeeTime.turn_division_title}
                          </>
                        ) : null}
                      </Badge>
                    </div>
                  ) : null}

                  <div className="client-portal-booking-booking-details-selection-container">
                    <div className="client-portal-booking-booking-details-selection-button-group">
                      <p className="client-portal-booking-booking-details-selection-title">{t("Holes")}</p>
                      <Radio.Group name="number_of_holes" onChange={handleHoleChange} value={bookingState.holeAmount}>
                        <Radio.Button value={18} disabled={holeButtons[0] || bookingFeePaid}>
                          <span className="mr-2">
                            {convertHoles(
                              18,
                              clientPortalStore?.selectedFacility?.courses?.find(
                                course => course.id === clientPortalStore?.selectedTeeTime?.course_id,
                              ),
                            )}
                          </span>
                          <FontAwesomeIcon size="1x" icon={["far", "golf-flag-hole"]} />
                        </Radio.Button>
                        <Radio.Button value={9} disabled={holeButtons[1] || bookingFeePaid}>
                          <span className="mr-2">
                            {convertHoles(
                              9,
                              clientPortalStore?.selectedFacility?.courses?.find(
                                course => course.id === clientPortalStore?.selectedTeeTime?.course_id,
                              ),
                            )}
                          </span>
                          <FontAwesomeIcon size="1x" icon={["far", "golf-flag-hole"]} />
                        </Radio.Button>
                      </Radio.Group>
                    </div>

                    <div className="client-portal-booking-booking-details-selection-button-group client-portal-booking-players-group">
                      <p className="client-portal-booking-booking-details-selection-title">{t("Players")}</p>
                      <div className="client-portal-booking-players-row">
                        <Radio.Group
                          name="number_of_golfers"
                          onChange={handleGolferAmountChange}
                          value={bookingState.golferAmount}
                        >
                          {singleTeePlayerButtons.map(playerCount => {
                            const disabledBySetting =
                              (playerCount === 1 && bookingState.disableSingleBooking) ||
                              (playerCount === 2 && bookingState.disableTwosomeBooking) ||
                              (playerCount === 3 && bookingState.disableThreesomeBooking) ||
                              (playerCount === 4 && bookingState.disableFoursomeBooking);

                            return (
                              <Radio.Button
                                key={`golfer_amount_${playerCount}`}
                                value={playerCount}
                                disabled={disabledBySetting || bookingFeePaid}
                              >
                                {playerCount}
                              </Radio.Button>
                            );
                          })}
                          {extraPlayerOptions.length > 0 && (
                            <Radio.Button
                              onClick={handleExtraPlayersVisible}
                              value={
                                bookingState.golferAmount > singleTeeBookingMax
                                  ? bookingState.golferAmount
                                  : -1
                              }
                              disabled={bookingFeePaid}
                            >
                              {bookingState.golferAmount > singleTeeBookingMax
                                ? bookingState.golferAmount
                                : "+"}
                            </Radio.Button>
                          )}
                        </Radio.Group>
                        <Dropdown
                          overlay={extraPlayersMenu()}
                          trigger="boolean"
                          placement="bottomLeft"
                          className="extra-players-menu"
                          showMenu={bookingState.extraPlayersDropdownVisible}
                          propRef={extraPlayersRef}
                          outSideClickDisable={true}
                        >
                          <span className="client-portal-extra-dropdown-anchor" />
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                </Card.Section>
              </Card>

              <Card>
                {clientPortalStore?.teeSheetSettings?.enable_cart_bookings ? (
                  <div>
                    {(clientPortalStore?.selectedTeeTime?.cart_rule === "optional" ||
                      clientPortalStore?.selectedTeeTime?.cart_rule === "required") && (
                        <Card.Section>
                          <div className="client-portal-booking-booking-details-selection-container">
                            <div
                              style={{ width: "100%" }}
                              className="client-portal-booking-booking-details-selection-button-group"
                            >
                              <p className="client-portal-booking-booking-details-selection-title">{t("Carts")}</p>
                              <div className="client-portal-booking-carts-row">
                                <Radio.Group
                                  name="number_of_carts"
                                  onChange={handleCartChange}
                                  value={bookingState.powerCartAmount}
                                >
                                  <Radio.Button value={0} disabled={cartsRequired || bookingFeePaid}>
                                    {t("Walking")}
                                  </Radio.Button>
                                  <Radio.Button disabled={cartsRequired || bookingFeePaid} value={1}>
                                    {t("1 Cart")}
                                  </Radio.Button>
                                  <Radio.Button
                                    disabled={cartsRequired || bookingFeePaid || bookingState.golferAmount <= 2}
                                    value={2}
                                  >
                                    {"2 Carts"}
                                  </Radio.Button>
                                  {extraCartOptions.length > 0 && (
                                    <Radio.Button
                                      onClick={handleExtraCartsVisible}
                                      value={bookingState.powerCartAmount > 2 ? bookingState.powerCartAmount : -1}
                                      disabled={cartsRequired || bookingFeePaid}
                                    >
                                      {bookingState.powerCartAmount > 2 ? bookingState.powerCartAmount : "+"}
                                    </Radio.Button>
                                  )}
                                </Radio.Group>
                                <Dropdown
                                  overlay={extraCartsMenu()}
                                  trigger="boolean"
                                  placement="bottomLeft"
                                  className="extra-carts-menu"
                                  showMenu={bookingState.extraCartsDropdownVisible}
                                  propRef={extraCartsRef}
                                  outSideClickDisable={true}
                                >
                                  <span className="client-portal-extra-dropdown-anchor" />
                                </Dropdown>
                              </div>
                            </div>
                          </div>
                        </Card.Section>
                      )}
                  </div>
                ) : null}

                <Card.Section>
                  <p className="client-portal-booking-booking-details-selection-title">{t("Golfers")}</p>
                  {[...Array(bookingState.golferAmount)]?.map((num, index) => {
                    if (bookingState.bookingParticipants[index]) {
                      return (
                        <div key={index} className="flex justify-between items-center w-full gap-4 mb-3">
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <GolferCard
                              bookingEngineCard={true}
                              closable={index > 0 && !bookingFeePaid}
                              removeGolfer={() => removeGolferFromBooking(index)}
                              name={bookingState.bookingParticipants[index]?.full_name}
                            />
                          </div>
                          {renderCartDriverToggle(index)}
                        </div>
                      );
                    } else {
                      const searchResultKey = "friendsSearchResult".concat((index + 1).toString());
                      return (
                        <div key={index} className="flex justify-between items-center w-full gap-4 mb-3">
                          <div className="new-player-sheet" style={{ flex: 1, minWidth: 0 }}>
                            <Select
                              showSearch
                              onSearch={(query: string) =>
                                clientPortalStore?.selectedTeeTime?.league_id
                                  ? searchLeagueParticipant(query, index)
                                  : handleCustomerSearch(query, "player".concat((index + 1).toString()))
                              }
                              onChange={(id: number, friendObject: ICustomerFriend) =>
                                clientPortalStore?.selectedTeeTime?.league_id
                                  ? handleLeagueParticipantSelection(id, friendObject)
                                  : handleCustomerSelection(id, friendObject)
                              }
                              allowClear
                              searchValue={
                                clientPortalStore?.selectedTeeTime?.league_id
                                  ? bookingState[`leagueParticipantQuery_${index + 1}`]
                                  : bookingState["player".concat((index + 1).toString())]
                              }
                              showDropDownOnFocus={!clientPortalStore?.selectedTeeTime?.league_id ? true : false}
                              searching={bookingState.searching}
                              placeholder={
                                clientPortalStore?.selectedTeeTime?.bookings_prevent_guests
                                  ? t("Select Members")
                                  : t("Guest")
                              }
                              disabled={bookingFeePaid}
                            >
                              {!clientPortalStore?.selectedTeeTime?.league_id && (
                                <div className="ui-select-dropdown-list-item" onClick={displayAddPlayerModal}>
                                  {t("Add New Playing Partner")}
                                </div>
                              )}
                              {clientPortalStore?.selectedTeeTime?.league_id
                                ? bookingState?.leagueParticipantList
                                  ?.filter(filteredParticipant =>
                                    filteredParticipant?.customer?.full_name
                                      ?.toLowerCase()
                                      .includes(bookingState[`leagueParticipantQuery_${index + 1}`]?.toLowerCase()),
                                  )
                                  ?.map((participant, participantIndex) => (
                                    <Option key={participantIndex} value={participant.user_id} extraValues={participant}>
                                      <span>{participant?.customer?.full_name}</span>
                                    </Option>
                                  ))
                                : renderFriendsList(searchResultKey)?.map((friend: ICustomerFriend, friendIndex: number) => {
                                  return (
                                    <Option key={friendIndex} value={friend.id} extraValues={friend}>
                                      <span>{friend.full_name}</span>
                                    </Option>
                                  );
                                })}
                            </Select>
                          </div>
                          {renderCartDriverToggle(index)}
                        </div>
                      );
                    }
                  })}

                  {clientPortalStore?.selectedTeeTime?.bookings_prevent_guests ? (
                    <p className="client-portal-booking-booking-details-selection-member-note">
                      {" "}
                      {t(
                        `Note: Only members of ${clientPortalStore?.selectedFacility?.full_name} may be added as playing partners`,
                      )}{" "}
                    </p>
                  ) : null}
                </Card.Section>
              </Card>

              {windowSize.width > MOBILE_WIDTH && (
                <>
                  {showPrepaidOptional || showPaymentDropdown ? (
                    <Card title={t("Payment Information")}>
                      {showPrepaidOptional ? (
                        <Card.Section>
                          <FormLayout>
                            <FormLayout.Group>
                              <Checkbox
                                label={t("Pay at course")}
                                checked={bookingState?.payAtCourse}
                                onChange={() =>
                                  setBookingState(prev => ({ ...prev, payAtCourse: true, payNow: false }))
                                }
                                circle
                                size="medium"
                                disabled={paymentState?.order?.balance > 0}
                              />
                            </FormLayout.Group>
                            <FormLayout.Group>
                              <Checkbox
                                label={t("Pay now")}
                                checked={bookingState?.payNow}
                                onChange={() =>
                                  setBookingState(prev => ({ ...prev, payNow: true, payAtCourse: false }))
                                }
                                circle
                                size="medium"
                                disabled={paymentState?.order?.balance > 0}
                              />
                            </FormLayout.Group>
                          </FormLayout>
                        </Card.Section>
                      ) : null}
                      {showPaymentDropdown ? (
                        <Card.Section>
                          <CustomerPaymentMethods
                            facility={clientPortalStore?.selectedFacility}
                            paymentMethodsState={paymentMethodState}
                            setPaymentMethodsState={setPaymentMethodState}
                            customerId={clientPortalStore?.user?.id}
                            paymentOptions={paymentOptions}
                            validateGiftCard={getGiftCardBalance}
                            //  termsChecked={bookingState?.acceptTerms}
                            creditCardRequired={
                              creditCardRequired ||
                              bookingState?.cart?.deposit_amount > 0
                            }
                            remainingPaymentAmount={remainingAmount}
                          />
                        </Card.Section>
                      ) : null}
                    </Card>
                  ) : null}
                  <Card>
                    <Card.Section title={t("Booking Notes")}>
                      <TextField
                        id="note"
                        value={bookingState?.note}
                        placeholder={t("Booking notes...")}
                        onChange={e => setBookingState(prev => ({ ...prev, note: e.target.value }))}
                        characterCountBottom
                        maxLength={150}
                      />
                    </Card.Section>
                  </Card>
                </>
              )}
            </div>
            <div className="client-portal-booking-main-container-right-side">
              <div className="client-portal-booking-order-summary">
                <Card>
                  <Card.Section>
                    <p className="client-portal-booking-booking-details-selection-title">{"Order Summary"}</p>
                    {orderSummaryObjects?.map((summaryObject, index) => {
                      return (
                        <OrderSummaryLineItem
                          key={index}
                          lineItem={summaryObject.lineItem}
                          itemValue={summaryObject.itemValue}
                        />
                      );
                    })}
                    <br />
                    {bookingState.loadPutCart || bookingState.cart === null ? (
                      <div className="h-8 mt-2 flex justify-center">
                        <Spin className="self-center" />
                      </div>
                    ) : (
                      <>
                        <p>{t("Items")}</p>
                        {bookingState.cart?.line_items?.map((lineItem: Record<string, any>, index: number) => {
                          const isPromotionalPrice = teeTimeHasPromotion && lineItem.product_type === "Green Fee";
                          return (
                            <OrderSummaryLineItem
                              key={index}
                              lineItemQuantity={lineItem.quantity}
                              lineItem={lineItem.product_title}
                              lineItemVariant={lineItem.variant_title}
                              prepaid={lineItem.pre_paid_required}
                              promotional={isPromotionalPrice}
                              promotionLabel={
                                isPromotionalPrice
                                  ? clientPortalStore?.selectedTeeTime?.promotion_label
                                  : undefined
                              }
                              itemValue={
                                <LocaleCurrency
                                  currency={bookingState.cart?.currency}
                                  amount={lineItem.subtotal_price}
                                />
                              }
                            />
                          );
                        })}

                        <br />

                        <OrderSummaryLineItem
                          lineItem={"Subtotal"}
                          itemValue={
                            <LocaleCurrency
                              currency={bookingState.cart?.currency}
                              amount={bookingState.cart?.subtotal_price}
                            />
                          }
                        />

                        {bookingState?.cart?.tax_lines?.map((taxLine: ITaxLine, index: number) => {
                          return (
                            <OrderSummaryLineItem
                              key={index}
                              lineItem={taxLine?.title ?? t("Tax")}
                              itemSubtitle={taxLine?.rate ? `${100 * taxLine?.rate}%` : undefined}
                              itemValue={
                                <LocaleCurrency currency={bookingState.cart?.currency} amount={taxLine?.price} />
                              }
                            />
                          );
                        })}

                        <OrderSummaryLineItem
                          lineItem={t("Total")}
                          itemValue={
                            <LocaleCurrency
                              currency={bookingState.cart?.currency}
                              amount={bookingState.cart?.total_price}
                            />
                          }
                        />

                        {paymentMethodState?.giftCardBalance || paymentMethodState?.creditBook ? (
                          <>
                            <br />
                            <p>{t("Discounts & Credits")}</p>
                            {paymentMethodState?.giftCardBalance ? (
                              <OrderSummaryLineItem
                                lineItem={"Gift card"}
                                itemValue={
                                  <LocaleCurrency
                                    currency={bookingState?.cart?.currency}
                                    amount={
                                      paymentMethodState?.giftCardBalance >= paymentDueState?.dueNow
                                        ? paymentDueState?.dueNow
                                        : paymentMethodState?.giftCardBalance
                                    }
                                  />
                                }
                              />
                            ) : null}

                            {paymentMethodState?.creditBook ? (
                              <OrderSummaryLineItem
                                lineItem={"Credit book"}
                                itemValue={
                                  <LocaleCurrency
                                    currency={paymentMethodState?.creditBook?.currency}
                                    amount={
                                      paymentMethodState?.creditBook?.balance >= paymentDueState?.dueNow
                                        ? paymentDueState?.dueNow
                                        : paymentMethodState?.creditBook?.balance
                                    }
                                  />
                                }
                              />
                            ) : null}
                          </>
                        ) : null}

                        {paymentState?.order ? (
                          <>
                            <br />
                            <p>{t("Transactions")}</p>
                            {paymentState?.order?.transactions?.map((transaction, index) => {
                              return (
                                <OrderSummaryLineItem
                                  key={index}
                                  lineItem={valueToString(transaction?.payment_type)}
                                  itemValue={
                                    <LocaleCurrency currency={transaction?.currency} amount={transaction?.amount} />
                                  }
                                />
                              );
                            })}
                          </>
                        ) : null}

                        <br />
                        <p className="client-portal-booking-order-summary-total-text">{t("Due at Course")}</p>
                        <p className="client-portal-booking-order-summary-total-price">
                          <LocaleCurrency
                            currency={bookingState.cart?.currency}
                            amount={paymentDueState?.dueAtCourse}
                          />
                        </p>

                        {paymentDueState?.depositDue > 0 && (
                          <>
                            <br />
                            <p className="client-portal-booking-order-summary-total-text">{t("Booking Deposit Due")}</p>
                            <p className="client-portal-booking-order-summary-total-price">
                              <LocaleCurrency
                                currency={bookingState.cart?.currency}
                                amount={paymentDueState?.depositDue}
                              />
                            </p>
                          </>
                        )}

                        {paymentDueState?.dueNow > 0 ? (
                          <>
                            <br />
                            <p className="client-portal-booking-order-summary-total-text">{t("Total Due Now")}</p>
                            <p className="client-portal-booking-order-summary-total-price">
                              <LocaleCurrency
                                currency={bookingState.cart?.currency}
                                amount={
                                  remainingAmount
                                    ? remainingAmount > 0
                                      ? remainingAmount
                                      : 0
                                    : paymentDueState?.dueNow
                                }
                              />
                            </p>
                          </>
                        ) : null}
                      </>
                    )}
                    
                    <div className="client-portal-booking-terms">
                      {clientPortalStore.selectedFacility.permissions?.email_marketing_allow_opt_ins &&
                        clientPortalStore.selectedFacility.permissions?.email_marketing_booking_page_checkbox && (
                          <Checkbox
                            id="acceptMarketingEmail"
                            size="small"
                            checked={bookingState.acceptMarketingEmail}
                            onChange={handleCheckboxChange}
                            borderStyle={{ outline: "1px solid black" }}
                            label={t('Subscribe to our emails')}
                          />
                        )}
                      <Checkbox
                        id="acceptTerms"
                        size="small"
                        checked={bookingState.acceptTerms}
                        onChange={handleCheckboxChange}
                        borderStyle={{ outline: "1px solid black" }}
                        label={
                          <span>
                            {t("I agree to the")}{" "}
                            <span onClick={e => displayTerms(e)} className="client-portal-booking-conditions">
                              {t("Terms and Conditions")}
                            </span>
                            <span className="ml-1">
                              {t("of")} {clientPortalStore?.selectedFacility?.long_name ?? ""}
                            </span>
                          </span>
                        }
                      />
                    </div>
                    <div className="client-portal-booking-booking-details-selection-confirm-button-group">
                      <Button
                        block
                        className="w-100"
                        size="medium"
                        type="default"
                        disabled={paymentState?.order?.balance > 0}
                        onClick={() => returnToHomePage(true)}
                      >
                        {t("Back")}
                      </Button>
                      <Button
                        className="w-100"
                        size="medium"
                        type="primary"
                        disabled={disableCheckout()}
                        block
                        onClick={
                          paymentDueState?.dueNow > 0 &&
                            !bookingFeePaid &&
                            clientPortalStore?.selectedTeeTime?.pre_paid_required
                            ? displayPrePaidWarning
                            : paymentDueState?.dueNow > 0 &&
                              bookingState?.cart?.total_price_due &&
                              paymentState?.step >= PaymentStep.post_cart &&
                              paymentState?.step <= PaymentStep.put_capture
                              ? displayBookingFeeWarning
                              : checkFriendsToAdd
                        }
                      >
                        {paymentDueState?.dueNow ? "Book and Pay" : "Confirm and Book"}
                      </Button>
                    </div>
                  </Card.Section>
                  {clientPortalStore?.teeSheetSettings?.booking_terms && (
                    <Card.Section title={t("Booking Terms")} collapsable defaultCollapsed>
                      <Markdown markdownText={clientPortalStore?.teeSheetSettings?.booking_terms} />
                    </Card.Section>
                  )}
                </Card>
                {windowSize.width <= MOBILE_WIDTH && (
                  <>
                    {showPrepaidOptional || showPaymentDropdown ? (
                      <Card title={t("Payment Information")}>
                        {showPrepaidOptional ? (
                          <Card.Section>
                            <FormLayout>
                              <FormLayout.Group>
                                <Checkbox
                                  label={t("Pay at course")}
                                  checked={bookingState?.payAtCourse}
                                  onChange={() =>
                                    setBookingState(prev => ({ ...prev, payAtCourse: true, payNow: false }))
                                  }
                                  circle
                                  size="medium"
                                  disabled={paymentState?.order?.balance > 0}
                                />
                              </FormLayout.Group>
                              <FormLayout.Group>
                                <Checkbox
                                  label={t("Pay now")}
                                  checked={bookingState?.payNow}
                                  onChange={() =>
                                    setBookingState(prev => ({ ...prev, payNow: true, payAtCourse: false }))
                                  }
                                  circle
                                  size="medium"
                                  disabled={paymentState?.order?.balance > 0}
                                />
                              </FormLayout.Group>
                            </FormLayout>
                          </Card.Section>
                        ) : null}
                        {showPaymentDropdown ? (
                          <Card.Section>
                            <CustomerPaymentMethods
                              facility={clientPortalStore?.selectedFacility}
                              paymentMethodsState={paymentMethodState}
                              setPaymentMethodsState={setPaymentMethodState}
                              customerId={clientPortalStore?.user?.id}
                              paymentOptions={paymentOptions}
                              validateGiftCard={getGiftCardBalance}
                              // termsChecked={bookingState?.acceptTerms}
                              creditCardRequired={
                                creditCardRequired ||
                                bookingState?.cart?.deposit_amount > 0
                              }
                              remainingPaymentAmount={remainingAmount}
                            />
                          </Card.Section>
                        ) : null}
                      </Card>
                    ) : null}

                    <Card>
                      <Card.Section title={t("Booking Notes")}>
                        <TextField
                          id="note"
                          value={bookingState?.note}
                          placeholder={t("Booking notes...")}
                          onChange={e => setBookingState(prev => ({ ...prev, note: e.target.value }))}
                          characterCountBottom
                          maxLength={150}
                        />
                      </Card.Section>
                    </Card>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Payment Terms Modal */}
        <Sheet
          size="small"
          height="flexible"
          open={bookingState.paymentTermsActive && windowSize.width > MOBILE_WIDTH}
          closable
          title={t("Payment Terms and Conditions")}
          cancelText={t("Close")}
          okText={t("Accept")}
          onOk={() => updateBookingState({ paymentTermsActive: false, acceptTerms: true })}
          onCancel={() => updateBookingState({ paymentTermsActive: false })}
          backDropCancel={false}
        >
          <Markdown markdownText={clientPortalStore?.teeSheetSettings?.payment_terms} />
        </Sheet>

        <Panel
          open={bookingState.paymentTermsActive && windowSize.width <= MOBILE_WIDTH}
          onClose={() => updateBookingState({ paymentTermsActive: false })}
          title={`${clientPortalStore?.selectedFacility?.long_name} Terms and Conditions`}
          animate
          primaryAction={{
            onClick: () => updateBookingState({ paymentTermsActive: false, acceptTerms: true }),
            label: t("Accept"),
          }}
          secondaryAction={{
            onClick: () => updateBookingState({ paymentTermsActive: false }),
            label: t("Close"),
          }}
        >
          <Markdown markdownText={clientPortalStore?.teeSheetSettings?.payment_terms} />
          <br />
          <Markdown markdownText={clientPortalStore?.teeSheetSettings?.booking_terms} />
        </Panel>

        {/* Add playing partner Modal */}
        <Panel
          open={bookingState.addPlayerModalVisible && windowSize.width < MOBILE_WIDTH}
          onClose={displayAddPlayerModal}
          title={t("Add Playing Partners")}
          animate
          primaryAction={{
            onClick: () => handleCustomerSelection(bookingState.selectedNewPlayer?.id, bookingState.selectedNewPlayer),
            label: t("Add Player"),
            disabled: bookingState.selectedNewPlayer ? false : true,
          }}
          secondaryAction={{
            onClick: displayAddPlayerModal,
            label: t("Cancel"),
          }}
        >
          {bookingState.selectedNewPlayer ? (
            <GolferCard
              closable
              removeGolfer={() => removeNewPlayerSelection()}
              name={bookingState.selectedNewPlayer?.full_name}
              email={bookingState.selectedNewPlayer?.email}
              bookingEngineCard={true}
            />
          ) : (
            <>
              <div className="client-portal-booking-search-player-label-container">
                <p className="text-sm text-subdued">{t("Search for public players using an email or phone number")}</p>
                <p className="text-sm text-subdued">
                  {t("Search for members using their name, email or phone number")}
                </p>
              </div>
              <Select
                showSearch
                onSearch={(query: string) => handleCustomerSearch(query, "newPlayerQuery")}
                onChange={(id: string, friendObject: ICustomerFriend) => handleNewPlayerSelection(id, friendObject)}
                allowClear
                searchValue={bookingState.newPlayerQuery}
                searching={bookingState.searching}
                placeholder={t("Search...")}
                noData={
                  <div className="no-players-found">
                    <FontAwesomeIcon icon={faUsersSlash} fixedWidth size="1x" />
                    <span>{"No player found.."}</span>
                  </div>
                }
              >
                {bookingState.customerSearchResult?.map((friend, index) => {
                  return (
                    <Option key={index} value={friend.id} extraValues={friend} name={friend?.full_name}>
                      <span>
                        {friend.full_name} - {friend?.customer_type[0]?.title}
                      </span>
                    </Option>
                  );
                })}
              </Select>
            </>
          )}
        </Panel>

        <Sheet
          open={bookingState.addPlayerModalVisible && windowSize.width > MOBILE_WIDTH}
          size="small"
          height="flexible"
          closable
          title={t("Add New Playing Partner")}
          onCancel={displayAddPlayerModal}
          onOk={() => handleCustomerSelection(bookingState.selectedNewPlayer?.id, bookingState.selectedNewPlayer)}
          cancelText={t("Cancel")}
          okText={t("Add Player")}
          okDisabled={bookingState.selectedNewPlayer ? false : true}
          overflow
        >
          {bookingState.selectedNewPlayer ? (
            <GolferCard
              closable
              removeGolfer={() => removeNewPlayerSelection()}
              name={bookingState.selectedNewPlayer?.full_name}
              email={bookingState.selectedNewPlayer?.email}
              bookingEngineCard={true}
            />
          ) : (
            <>
              <div className="client-portal-booking-search-player-label-container">
                <p className="text-sm text-subdued">{t("Search for public players using an email or phone number")}</p>
                <p className="text-sm text-subdued">
                  {t("Search for members using their name, email or phone number")}
                </p>
              </div>
              <Select
                showSearch
                onSearch={(query: string) => handleCustomerSearch(query, "newPlayerQuery")}
                onChange={(id: string, friendObject: ICustomerFriend) => handleNewPlayerSelection(id, friendObject)}
                allowClear
                searchValue={bookingState.newPlayerQuery}
                searching={bookingState.searching}
                placeholder={t("Search...")}
                noData={
                  <div className="no-players-found">
                    <FontAwesomeIcon icon={faUsersSlash} fixedWidth size="1x" />
                    <span>{"No player found.."}</span>
                  </div>
                }
              >
                {bookingState.customerSearchResult?.map((friend, index) => {
                  return (
                    <Option key={index} value={friend.id} extraValues={friend}>
                      <span>
                        {friend.full_name} - {friend?.customer_type[0]?.title}
                      </span>
                    </Option>
                  );
                })}
              </Select>
            </>
          )}
        </Sheet>

        {/* Add friends modal */}
        <Sheet
          size="small"
          height="flexible"
          open={addFriendState?.modalVisible}
          closable
          title={t("Add Playing Partners")}
          okText={t("Confirm and Book")}
          onOk={handleAddFriends}
          onCancel={() =>
            setAddFriendState(prevState => ({
              ...prevState,
              friendsToAdd: [],
              modalVisible: false,
              selectedPlayerIds: [],
            }))
          }
          backDropCancel={false}
          stacked
        >
          <div className="client-portal-booking-add-playing-partners">
            <p className="confirmation-text">
              {t("Would you like to add the following golfers to your playing partners list?")}
            </p>
            {addFriendState?.friendsToAdd?.map((participant: ICustomerFriend, index) => {
              return (
                <div
                  key={index}
                  className="add-player-container"
                  onClick={() => handleAddPlayerCheckbox(participant?.id)}
                >
                  <div className="add-player-checkbox">
                    <Checkbox
                      size="small"
                      checked={addFriendState?.selectedPlayerIds?.includes(participant?.id) ?? false}
                      onChange={() => handleAddPlayerCheckbox(participant?.id)}
                    />
                  </div>
                  <div className="player-image-container">
                    <div className="client-portal-profile-default-image">
                      <p>
                        {participant?.first_name?.charAt(0)?.toUpperCase()}
                        {participant?.last_name?.charAt(0)?.toUpperCase()}
                      </p>
                    </div>
                  </div>
                  <div className="player-info-conatiner">
                    <p className="player-name">{participant?.full_name}</p>
                    <p className="confirmation-text">{participant?.email}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </Sheet>

        <Popup
          open={prepaidWarning?.open}
          type="info"
          title={prepaidWarning?.title}
          description={prepaidWarning?.description}
          onCancel={() => setPrepaidWarning({ open: false, title: "", description: "" })}
          onOk={checkFriendsToAdd}
        />
      </>
    )
  );
}
